import { DatePipe } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { select, Store } from '@ngrx/store';
import { TransitionHookScope } from '@uirouter/core';
import moment, { max } from 'moment';
import { merge, Observable, ReplaySubject, Subscription } from 'rxjs';
import { filter, takeWhile, tap } from 'rxjs/operators';
import Tabulator from 'tabulator-tables';
import { CellColorManager } from './cell-color-manager';
import * as fromAuth from '../../auth/store/auth.reducer';
import { CompanySetting } from '../../company-setting';
import { TimecardSequence } from '../../data-services';
import { SignaturePolicy } from '../../data-services/signature-policy';
import * as fromLookups from '../../lookups';
import * as fromShared from '../../shared';
import { Process } from '../../shared';
import { AutoComplete } from '../../shared/efaact-primeng.module';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { TabulatorService } from '../../tabulator.service';
import {
    IUser,
    IUserColor,
    IUserInfo,
    SetSignaturePolicy,
    UserRoleEnum
} from '../../user-info';
import * as fromUser from '../../user-info/store/user.reducer';
import { IDirectReportsWithTimeStatus } from '../IDirectReportsWithTimeStatus';
import { IDirectReport, IManagementAction } from '../IManagementAction';
import { ITimeCard } from '../itime-card';
import { ITimeCardSubmit } from '../ITimeCardSubmit';
import { IWeeklySummary } from '../IWeeklySummary';
import * as fromTimecard from '../store';
import * as fromDRWTS from '../store/direct-reports-with-time-status.actions';
import * as fromdrwtsR from '../store/direct-reports-with-time-status.reducer';
import { TimeCardDocumentation } from '../store/time-card-documentation.model';
import * as docReducers from '../store/time-card-documentation.reducer';
import * as fromWeeklySummary from '../store/weekly-summary.actions';
import { TimeCardService } from '../time-card.service';
import { TimecardUnsavedStateService } from '../timecard-unsaved-state.service';

interface IRequiredCommentEntry {
    key: string;
    task: string;
    date: string;
    comment: string;
    changeSummary: string;
}

@Component({
    selector: 'ef-time-card-presenter',
    templateUrl: './time-card-presenter.component.html',
    styleUrls: ['./time-card-presenter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TimeCardPresenterComponent
    implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
    showAvailableHoursColumn: boolean = false;
    showMyDRs = true;
    tabManagementRows: any[];
    useDirectReportCards = true;
    selectedDirectReport?: IDirectReportsWithTimeStatus;
    selectedDirectReportId?: string;
    expandedDirectReportId?: string;
    directReportSearchTerm = '';
    directReportSortBy = 'name';
    directReportSortOptions = [
        { label: 'Name', value: 'name' },
        { label: 'Signed', value: 'Signed' },
        { label: 'Saved', value: 'Saved' },
        { label: 'Approved', value: 'Approved' },
        { label: 'Validated', value: 'Validated' },
        { label: 'Disapproved', value: 'Disapproved' },
        { label: 'Documented', value: 'Documented' }
    ];
    public moment: any;
    showAccrualsOnTimeCard: any;
    mgmtActionInProgress: boolean;
    @Input() set directReportTimeStatusData(
        value: Array<IDirectReportsWithTimeStatus>
    ) {
        if (this.isSuperUser || this.isUser) {
            if (!this.useDirectReportCards) {
                this.createTabulatorForManagementUsers(this, [], ['']);
            }
            // Do not load
        } else {
            this._directreportswithtimestatus = value.map(x => ({ ...x }));
            this.DRSubject.next(this._directreportswithtimestatus);

            if (this.useDirectReportCards) {
                if (this.directReportListID) {
                    const match = this._directreportswithtimestatus.find(
                        report =>
                            report.EmployeeListID === this.directReportListID
                    );
                    if (match) {
                        this.setSelectedDirectReport(match, false);
                    } else {
                        this.selectedDirectReport = undefined;
                        this.selectedDirectReportId = undefined;
                        this.expandedDirectReportId = undefined;
                    }
                }
                if (
                    this.isDRSelected === false &&
                    this._directreportswithtimestatus.length > 0
                ) {
                    this.selectInitialDR();
                }
            } else {
                if (this.tabManagement && this.directReportListID) {
                    this.tabManagement.replaceData(
                        this._directreportswithtimestatus
                    );
                    this.tabManagementRows = this.tabManagement.getRows();
                    let selectedrow;
                    this.tabManagementRows.forEach(row => {
                        if (
                            row._row.data.EmployeeListID ===
                            this.directReportListID
                        ) {
                            selectedrow = row;
                        }
                    });
                    this.selectedDRRow = selectedrow;
                    if (this.selectedDRRow) {
                        this.selectedDRRow
                            .getElement()
                            .classList.add('highlight');
                        if (this.process) {
                            if (this.process.ProcessID == 85) {
                                this.weeklySummaryHeader =
                                    'Weekly Summary for Approval Period';
                            }
                            if (this.process.ProcessID == 87) {
                                this.weeklySummaryHeader =
                                    'Weekly Summary for Validate Period';
                            }
                        } else {
                            this.weeklySummaryHeader =
                                'Weekly Summary for Approval Period';
                        }
                    }
                } else {
                    this.createTabulatorForManagementUsers(
                        this,
                        this._directreportswithtimestatus,
                        ['']
                    );

                    if (
                        this.isDRSelected === false &&
                        this._directreportswithtimestatus.length > 0
                    ) {
                        this.selectInitialDR();
                    }
                }
            }
        }
    }
    get directReportTimeStatusData(): Array<IDirectReportsWithTimeStatus> {
        return this._directreportswithtimestatus;
    }
    hasMaxHours: boolean;
    @Input() set timecardData(value: Array<ITimeCard>) {
        // if (value && value.length) {
        this.log.verbose({
            type: 'TimeCardPresenterComponent:timecarddata:set',
            value
        });
        const previousListID = this._timecarddata?.[0]?.EmployeeListID;
        const newListID = value?.[0]?.EmployeeListID;
        this._timecarddata = value;
        if (!this.saveOnCellBlur && (previousListID !== newListID || value?.length === 0)) {
            this.pendingTimeCardUpdates.clear();
            this.setHasUnsavedChanges(false);
        }
        this.showSI = !value.every(x => x && x.ServiceItem === null);
        this.hasMaxHours = value.some(x => x && x.AvailableHours != null);
        this.log.verbose({
            type: 'TimeCardPresenterComponent:timecarddata:set',
            value: `showSI in timecard set = ${this.showSI}`
        });
        this.TimeCardsSubject.next(value);
        this.createTimeCardHeader(value, 'LeaveAccrualInfo');
        // }
    }
    get timecardData(): Array<ITimeCard> {
        return this._timecarddata;
    }

    private WeeklySummarySubject = new ReplaySubject<Array<IWeeklySummary>>(1);
    private _weeklysummarydata: Array<IWeeklySummary>;
    @Input() set weeklySummaryData(value: Array<IWeeklySummary>) {
        if (value != null && value.length > 0) {
            this.log.verbose({
                type: 'TimeCardPresenterComponent:timecarddata:set',
                value
            });
            // value.forEach(x => {
            //     if (x.AvailableHours == null) {
            //         x.AvailableHours = 0;
            //     }
            // })
            this._weeklysummarydata = value;
            this.wsShowSI = !value.every(x => x.ServiceItem === null);
            this.log.verbose({
                type: 'TimeCardPresenterComponent:weeklySummaryData:set',
                wsShowSI: this.wsShowSI
            });

            this.WeeklySummarySubject.next(value);

            if (this.isSupervisor || this.isTaskManager) {
                this.createWeeklySummaryHeader(value);
            }
        } else {
            this._weeklysummarydata = value ?? [];
            this.wsShowSI = false;
            this.flippedSummaryData = [];
            this.WeeklySummarySubject.next(value);
            if (this.tabWeeklySummary) {
                this.tabWeeklySummary.clearData();
            }
        }
    }
    get weeklySummaryData(): Array<IWeeklySummary> {
        return this._weeklysummarydata;
    }

    get weeklySummaryRowCount(): number {
        if (this.flippedSummaryData && this.flippedSummaryData.length > 0) {
            return this.flippedSummaryData.length;
        }
        if (!this.weeklySummaryData || this.weeklySummaryData.length === 0) {
            return 0;
        }
        return this.weeklySummaryData.length;
    }

    get weeklySummaryWeekCount(): number {
        if (!this.weeklySummaryData || this.weeklySummaryData.length === 0) {
            return 0;
        }
        const weeks = new Set(
            this.weeklySummaryData
                .map(item => item.TimeWeek)
                .filter(week => !!week)
        );
        return weeks.size;
    }

    get documentationTaskCount(): number {
        if (!this.documentationRows || this.documentationRows.length === 0) {
            return 0;
        }
        const tasks = new Set<string>();
        this.documentationRows.forEach(row => {
            const rawTask = row?.TaskLongName ?? '';
            const task = String(rawTask).trim();
            if (task) {
                tasks.add(task);
            }
        });
        return tasks.size;
    }

    get documentationHoursTotal(): number {
        return this.sumDocumentationMetric('EmpTimeIDHours');
    }

    get documentationDocumentedHoursTotal(): number {
        return this.sumDocumentationMetric('Hours');
    }

    formatMetricValue(value: number | null | undefined): string {
        const safeValue = Number(value);
        const finalValue = Number.isFinite(safeValue) ? safeValue : 0;
        return finalValue.toFixed(this.summaryDecimalPlaces);
    }

    private get summaryDecimalPlaces(): number {
        const setting = this.companySettings && this.companySettings[0];
        const places = setting ? Number(setting.SettingValue) : 2;
        return Number.isFinite(places) ? places : 2;
    }

    private sumTimecardMetric(
        field: 'periodTotal' | 'TotalDocumentedHours'
    ): number {
        if (!this.sortedByTask || this.sortedByTask.length === 0) {
            return 0;
        }
        return this.sortedByTask.reduce((total, row) => {
            const value = Number(row?.[field]);
            return total + (Number.isFinite(value) ? value : 0);
        }, 0);
    }

    private sumDocumentationMetric(
        field: 'EmpTimeIDHours' | 'Hours'
    ): number {
        if (!this.documentationRows || this.documentationRows.length === 0) {
            return 0;
        }
        return this.documentationRows.reduce((total, row) => {
            const value = Number(row?.[field]);
            return total + (Number.isFinite(value) ? value : 0);
        }, 0);
    }

    private getDocumentedHoursForEmpAuth(
        empAuthID: number | string
    ): number {
        if (
            empAuthID === null ||
            empAuthID === undefined ||
            !this.timecardData ||
            this.timecardData.length === 0 ||
            !this.documentationRows ||
            this.documentationRows.length === 0
        ) {
            return 0;
        }

        const timeIds = new Set(
            this.timecardData
                .filter(tc => tc.EmpAuthID === empAuthID)
                .map(tc => tc.EmpTimeID)
                .filter(id => !!id)
        );

        if (timeIds.size === 0) {
            return 0;
        }

        return this.documentationRows.reduce((total, row) => {
            if (!row?.EmpTimeID || !timeIds.has(row.EmpTimeID)) {
                return total;
            }
            const value = Number(row?.Hours);
            return total + (Number.isFinite(value) ? value : 0);
        }, 0);
    }

    getWeeklySummaryValue(
        field: 'PeriodTotal' | 'AvailableHours'
    ): number | null {
        if (!this.weeklySummaryData || this.weeklySummaryData.length === 0) {
            return null;
        }
        if (field === 'PeriodTotal') {
            const totalsByTask = new Map<string, number>();
            this.weeklySummaryData.forEach(item => {
                const key =
                    item.EmpAuthID != null
                        ? String(item.EmpAuthID)
                        : String(item.TaskLongName ?? '').trim();
                if (!key || totalsByTask.has(key)) {
                    return;
                }
                const value = Number(item[field]);
                if (Number.isFinite(value)) {
                    totalsByTask.set(key, value);
                }
            });
            const sum = Array.from(totalsByTask.values()).reduce(
                (total, value) => total + value,
                0
            );
            return totalsByTask.size > 0 ? sum : null;
        }
        const entry = this.weeklySummaryData.find(
            item => item[field] !== null && item[field] !== undefined
        );
        return entry ? entry[field] : null;
    }
    showAvailableHoursOnTimecard: any = false;
    showTimeCardLockForSupervisors: any;
    private CompanySettingsSubject = new ReplaySubject<Array<CompanySetting>>(
        1
    );
    private _companysettings: Array<CompanySetting>;
    @Input() set companySettings(value: Array<CompanySetting>) {
        if (value.length > 0) {
            if (value.findIndex(x => x.SettingType == 'ShowAccrualsOnTimeCard') != -1) {
                this.showAccrualsOnTimeCard = value.find(x => x.SettingType == 'ShowAccrualsOnTimeCard').SettingValue;
                this.showAccrualsOnTimeCard = this.showAccrualsOnTimeCard == 1 ? true : false;
            }
            if (value.findIndex(x => x.SettingType == 'LockTimeCardsForSupervisor') != -1) {
                this.showTimeCardLockForSupervisors = value.find(x => x.SettingType == 'LockTimeCardsForSupervisor').SettingValue;
                this.showTimeCardLockForSupervisors = this.showTimeCardLockForSupervisors == 1 ? true : false;
            }
            if (
                value.find(
                    setting => setting.SettingType == 'ShowAvailableHours'
                ) != null
            ) {
                this.showAvailableHoursOnTimecard = value.find(
                    setting => setting.SettingType == 'ShowAvailableHours'
                ).SettingValue;
                this.showAvailableHoursOnTimecard =
                    this.showAvailableHoursOnTimecard == 1 ? true : false;
            }

            value = value.filter(
                setting => setting.SettingType == 'time_precision'
            );
        }

        this._companysettings = value;
        this.CompanySettingsSubject.next(value);
    }
    get companySettings(): Array<CompanySetting> {
        return this._companysettings;
    }

    private TimecardSequenceSubject = new ReplaySubject<
        Array<TimecardSequence.TimecardSequence>
    >(1);
    private _timecardsequence: Array<TimecardSequence.TimecardSequence>;
    @Input() set timecardSequence(
        value: Array<TimecardSequence.TimecardSequence>
    ) {
        if (value && value.length > 0) {
            value = value.sort((a, b) => a.Tasksortorder - b.Tasksortorder);
        }
        this._timecardsequence = value;
        this.TimecardSequenceSubject.next(value);
    }
    get timecardSequence(): Array<TimecardSequence.TimecardSequence> {
        return this._timecardsequence;
    }

    private ManagementActionRespSubject = new ReplaySubject<any>(1);
    private _managementactionresp: any;
    @Input() set managementActionResp(
        value: any
    ) {
        if (value) {
            if (value.Items) {
                if (value.Items.length > 0) {
                    this.managementActionMessage = value.ErrorMessages[0] ? value.ErrorMessages[0] : 'Management Action Successful';
                    this.managementActionCompleteMsg = this.managementActionMessage;
                }
            }
        }
        this._managementactionresp = value;
        this.ManagementActionRespSubject.next(value);

    }
    get managementActionResp(): any {
        return this._managementactionresp;
    }

    managementActionMessage: string;

    constructor(
        @Inject(LoggingService) private log: LoggingService,
        @Inject(TabulatorService) private tabService: TabulatorService,
        private errorStore: Store<fromShared.Errors.State>,
        @Inject(UnsavedChangesService)
        private confirmservice: UnsavedChangesService,
        private store: Store<fromTimecard.State>,
        private userStore: Store<fromUser.State>,
        private authStore: Store<fromAuth.State>,
        private timeCardService: TimeCardService,
        private dRstore: Store<fromdrwtsR.State>,
        private timecardUnsavedStateService: TimecardUnsavedStateService
    ) {
        this.moment = moment;
        this.filterFormGroup = new UntypedFormGroup({
            directReports: new UntypedFormControl(null),
            tasks: new UntypedFormControl(null)
        });

        this.approveFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(null),
            approve: new UntypedFormControl(null),
            lock: new UntypedFormControl(null),
            unlock: new UntypedFormControl(null)
        });

        this.disapproveFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(null),
            disapprove: new UntypedFormControl(null)
        });

        this.unapproveFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(null),
            unapprove: new UntypedFormControl(null)
        });

        this.validateFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(new Date()),
            validate: new UntypedFormControl(null)
        });

        this.disapproveValidateFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(null),
            disapprove: new UntypedFormControl(null)
        });

        this.unvalidateFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(null),
            unvalidate: new UntypedFormControl(null)
        });
    }
    @Input() public signaturePolicy: SignaturePolicy[];
    @Input() public process: Process;
    @ViewChild('weekZeroHeader', { static: true })
    weekZeroHeader: ElementRef;
    @ViewChild('weekOneHeader', { static: true })
    weekOneHeader: ElementRef;
    @ViewChild('weekTwoHeader', { static: true })
    weekTwoHeader: ElementRef;
    @ViewChild('weekThreeHeader', { static: true })
    weekThreeHeader: ElementRef;
    @ViewChild('weekFourHeader', { static: true })
    weekFourHeader: ElementRef;
    @ViewChild('weekFiveHeader', { static: true })
    weekFiveHeader: ElementRef;
    @ViewChild('weekSixHeader', { static: true })
    weekSixHeader: ElementRef;
    @ViewChild('cbxColumnHeader', { static: true })
    cbxColumnHeader: MatCheckbox;
    @ViewChild('superUserTableCbxColumnHeader', { static: true })
    superUserTableCbxColumnHeader: MatCheckbox;
    @ViewChild('weeklySummaryPanel', { read: ElementRef })
    weeklySummaryPanel?: ElementRef;
    public selectedCheckbox = { checked: false, indeterminate: false };
    public superUSerTableSelectedCheckbox = {
        checked: false,
        indeterminate: false
    };
    public filterFormGroup: UntypedFormGroup;
    public approveFormGroup: UntypedFormGroup;
    public disapproveFormGroup: UntypedFormGroup;
    public unapproveFormGroup: UntypedFormGroup;
    public validateFormGroup: UntypedFormGroup;
    public disapproveValidateFormGroup: UntypedFormGroup;
    public unvalidateFormGroup: UntypedFormGroup;

    public tabTimeCard: Tabulator;
    public tabManagement: Tabulator;
    public tabWeeklySummary: Tabulator;
    public Allowsplitday: boolean;
    public IsDisabled = true;
    public active = true;
    private documentationRows: Array<TimeCardDocumentation> = [];
    public isUser = false;
    public isSuperUser = false;
    public isSupervisor = false;
    public isTaskManager = false;
    public tabEndOfRow = false;

    public rangeDates: Array<Date>;

    public flippedTimeCardData: Array<IFlippedData>;
    public flippedSummaryData: Array<IFlippedWSData>;

    public selectedDirectReports: Array<IDirectReport> = [];
    public activeDirectReports: Array<fromLookups.IDirectReport> = [];
    public incorrectPassword = false;
    public timecardHeader: string;
    public timecardDocHeader: string = 'Timecard Documentation';
    public weeklySummaryHeader: string;
    public employeeName = '';
    public employeeListID = '';
    public enteredPassword = '';
    public changeMessage = '';
    public roleGroupID = -1;
    public userEntryStartDate: string;
    public userEntryEndDate: string;
    public display = 'Task & Service Item';
    public columnID = -1;
    public IsReadOnly = false;
    public start = '';
    @Input() public userWebColors: Array<IUserColor>;
    public user: IUserInfo;
    public signaturePolicyRequired: boolean;
    public selectedProcessRole: any;
    public dynamicTableHeight = '33vh';
    public dynamicSummaryTableHeight = '17vh';
    weeklySummaryCollapsed = true;
    private weeklySummaryExpandedHeight = 0;
    private weeklySummaryCollapsedHeight = 0;
    private timecardBaseHeightPx?: number;
    private lastAppliedTimecardHeightPx?: number;
    public cbxValue = false;
    public isDRSelected = false;
    public dr_panelExpanded = false;
    public ws_panelExpanded = true;
    public tc_panelExpanded = false;
    public nextButtonHidden = false;
    public prevButtonHidden = false;
    public displayNotePopup = false;
    public displayBulkCommentPopup = false;
    public displayPolicyPopup = false;
    public currentRow: any;
    public currentCell: any;
    public currentDay: any;
    public changeCommentTask: string;
    public changeCommentDate: string;
    public previousCellValue;
    public drMinEntryDate: string;
    public drMaxEntryDate: string;
    public numOfDaysInWeek: number;
    public PeriodHasSplitDay: boolean;
    public previousWeekClicked = false;
    public nextWeekClicked = false;
    public timePolicyCbxChecked = false;
    public userSub$: Observable<IUser>;
    public authSub: Subscription;
    public userInfoSubject = new ReplaySubject<IUserInfo>(1);
    public selectedEndDate: Date;
    public EmployeeIdSubject = new ReplaySubject<string>(1);
    @Output() refreshStatusEE = new EventEmitter<INextOrPrevious>();
    public ActionsSubject = new ReplaySubject<string>(1);
    @Output() nextOrPrevious = new EventEmitter<INextOrPrevious>();
    @Output() tcSubmit = new EventEmitter<Array<ITimeCardSubmit>>();
    @Output() dRSelectedSubject = new ReplaySubject<any>(1);
    @Output() supervisorDRSelected = new EventEmitter<any>();
    @Output() actionDateSelected = new EventEmitter<{
        EndDate: string;
        StartDate: string;
        Role: number;
        MyDRsOnly: boolean;
    }>();
    @Output() actionDate = new ReplaySubject<{
        EndDate: string;
        StartDate: string;
        Role: number;
    }>();
    @Output() timeCardUpdate = new EventEmitter<Array<ITimeCard>>();
    @Output() managementUpdate = new EventEmitter<IManagementAction>();
    @Output() updateTasks = new EventEmitter<fromLookups.IDirectReport>();
    @Output() AddDocumentation = new ReplaySubject<ITimeCard>(1);
    @Output() LoadSignaturePolicy = new ReplaySubject<any>(1);
    @Output() LoadTimecardSequence = new ReplaySubject<any>(1);
    @Output() SaveTimecardSequence = new ReplaySubject<any>(1);
    @Output() LoadMgmtLoadTimecardandWeeklySummary = new ReplaySubject<any>(1);

    public confirmClicked: boolean;
    public userPassword: string;
    public managementRowSelected = false;
    public tabAlreadyCreated = false;
    public sortedByTask: any[] = [];
    public disableRefreshButton = true;
    public directReportListID: string;
    /** When false, cell edits are staged until user clicks Save. When true, legacy behavior: save on cell blur. */
    public saveOnCellBlur = false;
    public hasUnsavedChanges = false;
    /** Pending timecard day updates keyed by id (EmpAuthID + WorkDateHdr) for deduplication. */
    private pendingTimeCardUpdates = new Map<string, ITimeCard>();
    /** Original hours keyed by pending id to show change context in required-comment dialog. */
    private pendingOriginalHours = new Map<string, number | null>();
    public selectedDR: fromLookups.IDirectReport;
    public drdropdown = false;
    public dRtoAdd: Array<IDirectReport> = [];
    public isRefreshing = false;
    public showSignaturePolicy: boolean;
    leaveInfo: string;
    requireTimeSubmit: boolean;
    requireSubmitFlag = false;
    private deferredSubmitType: 'week' | 'period' | null = null;
    managementActionEndDate: string;
    timeCardSubmitOb: Observable<any>;
    todaysDate: Date;
    timeweek: any;
    timeweek0: any;
    timeweek1: any;
    timeweek2: any;
    timeweek3: any;
    timeweek4: any;
    timeweek5: any;
    timeweek6: any;
    timeweek7: any;
    accountNumber: string;
    mgrComment: string;
    dialogVisible = false;
    managementActionData: IManagementAction;
    IsDateSelected = false;
    weeklyHeaderSelected = false;
    displayDeleteWarningPopup = false;
    directReportHeader = 'Direct Report Time Status for Approval Period';
    firstDate: any;
    secondDate: any;
    fullDateRangeSelected: boolean;
    selectedDRRow: any;
    showSI: any;
    wsShowSI: any;
    msgs: any[];
    bulkCommentMsgs: any[] = [];
    requiredCommentEntries: IRequiredCommentEntry[] = [];
    bulkCommentActiveTabIndex = 0;
    mgmtRowSelection: string;
    mgmtCell: any;
    selectedCellValue: any;
    displayDocumentationExceedingHoursWarningPopup = false;
    showNegativeHoursDialog = false;
    showManagementActionDialog = false;
    showManagementActionErrorDialog = false;
    selectedCellDate: string;
    selectedCellTask: any;
    selectedCellStatus: string;
    dblClickDirections: string;
    displayDocWarning = false;
    displayOver24HoursWarning = false;
    managementActionCompleteMsg = '';
    showManagementActionCompleteMsg = false;
    pswdForSig: string;
    showSignaturePolicyError = false;
    expectedHours: number;
    activeTab: any;

    @Output() LoadDirectReportsWithTimeStatus = new ReplaySubject(1);
    IsLoading = true;
    detailsLabel: string;
    displayReorderTasks = false;
    displayDocumentation = false;

    tabIndex = 0;

    pivot = true;

    private DRSubject = new ReplaySubject<Array<IDirectReportsWithTimeStatus>>(
        1
    );
    private _directreportswithtimestatus: Array<IDirectReportsWithTimeStatus>;

    public TimeCardsSubject = new ReplaySubject<Array<ITimeCard>>(1);
    private _timecarddata: Array<ITimeCard>;

    timecardAccrualInfo: string;

    mgmtDateRangeStart: any;
    mgmtDateRangeEnd: any;
    DRName: string;

    emptyWeeklyTabPlaceholder: string = "No Data Available";

    signPeriod = false;
    signWeek = false;

    @Input() public directReports: Array<fromLookups.IDirectReport>;
    createTimeCardHeader(data, field) {
        const el = data[0];
        if (el != null) {
            if (el.LeaveAccrualInfo != null) {
                const noneUpdated = data.every(x => el[field] === x[field]);
                if (noneUpdated == true) {
                    this.timecardAccrualInfo = data[0].LeaveAccrualInfo;
                    this.timecardHeader =
                        'TimeCard' +
                        '\xa0\xa0' +
                        this.findEmployeeName(el.EmployeeListID) +
                        '\xa0\xa0' +
                        data[0].LeaveAccrualInfo;
                } else {
                    data.forEach(x => {
                        if (x[field] !== el[field]) {
                            this.timecardAccrualInfo = x[field];
                            this.timecardHeader =
                                'TimeCard' +
                                '\xa0\xa0' +
                                this.findEmployeeName(el.EmployeeListID) +
                                '\xa0\xa0' +
                                x[field];
                        }
                    });
                }
            } else {
                this.timecardHeader =
                    'TimeCard' +
                    '\xa0\xa0' +
                    this.findEmployeeName(el.EmployeeListID);
            }
        } else {
            this.timecardHeader = 'TimeCard';
        }
    }

    createWeeklySummaryHeader(data) {
        if (this.process) {
            if (this.process.ProcessID == 85) {
                this.weeklySummaryHeader = 'Weekly Summary for Approval Period';
            }
            if (this.process.ProcessID == 87) {
                this.weeklySummaryHeader = 'Weekly Summary for Validate Period';
            }
        } else {
            this.weeklySummaryHeader = 'Weekly Summary for Approval Period';
        }
    }

    findEmployeeName(id) {
        let employeeName;
        if (id != null) {
            if (this.isTaskManager || this.isSupervisor) {
                if (
                    this.directReportTimeStatusData &&
                    this.directReportTimeStatusData.length > 0
                ) {
                    employeeName = this.directReportTimeStatusData.find(
                        x => x.EmployeeListID == id
                    ).UserName;
                } else if (this.user) {
                    employeeName = this.user.EmployeeName;
                } else {
                    employeeName = id;
                }
            } else {
                if (this.directReports && this.directReports.length > 0) {
                    employeeName = this.directReports.find(
                        x => x.EmployeeListID == id
                    );
                    if (employeeName) {
                        employeeName = employeeName.EmployeeName;
                    } else {
                        employeeName = '';
                    }
                } else if (this.user) {
                    employeeName = this.user.EmployeeName;
                } else {
                    employeeName = id;
                }
            }
        }

        return employeeName;
    }

    ngOnInit() {
        this.setupObservables();
        this.setupSubscriptions();

        this.selectedProcessRole = this.getProcessRole(
            this.process.ProcessID,
            this.user
        );
        this.setProcessRole(this.selectedProcessRole); // this needs to be before i ever reference isSupervisor ect...

        if (this.process) {
            switch (this.process.ProcessID) {
                case 90: // super user
                    sessionStorage.removeItem('mgmtEndDate');
                    this.dblClickDirections =
                        'Once saved, double-click a time entry to document.';
                    this.dynamicSummaryTableHeight = '22vh';
                    break;
                case 64: // entry
                    sessionStorage.removeItem('mgmtEndDate');
                    this.dblClickDirections =
                        'Once saved, double-click a time entry to document.';
                    this.dynamicSummaryTableHeight = '22vh';
                    break;
                case 85: // approve
                    this.dblClickDirections =
                        'Double-click hour(s) to perform a management action.';
                    this.dynamicSummaryTableHeight = '17vh';
                    break;
                case 87: // validate
                    this.dblClickDirections =
                        'Double-click hour(s) to perform a management action.';
                    this.dynamicSummaryTableHeight = '17vh';
                    break;
                default:
                    this.dblClickDirections =
                        'Once saved, double-click a time entry to document.';
                    this.dynamicSummaryTableHeight = '22vh';
                    break;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.directReports) {
            const dr = changes.directReports.currentValue;
            if (dr && dr.length > 0 && this.user) {
                this.activeDirectReports = dr.filter(x => x.IsActive === true);
                this.activeDirectReports = this.activeDirectReports.filter(
                    x => x.IsValidUser === true && x.EmployeeListID != this.user.EmployeeListID
                );
                // var currentSignedInUser = this.activeDirectReports.find(x => x.EmployeeListID == this.user.EmployeeListID);
                this.approveFormGroup.controls['dateRange'].patchValue([
                    // new Date(this.activeDirectReports[0].MinWorkDate),
                    // new Date(this.activeDirectReports[0].MaxWorkDate)
                    new Date(this.user.UserEntryStartDate),
                    new Date(this.user.UserEntryEndDate)
                ]);
                this.validateFormGroup.controls['dateRange'].patchValue([
                    new Date(this.user.UserEntryStartDate),
                    new Date(this.user.UserEntryEndDate)
                ]);
                this.disapproveFormGroup.controls['dateRange'].patchValue([
                    new Date(this.user.UserEntryStartDate),
                    new Date(this.user.UserEntryEndDate)
                ]);
                this.disapproveValidateFormGroup.controls[
                    'dateRange'
                ].patchValue([
                    new Date(this.user.UserEntryStartDate),
                    new Date(this.user.UserEntryEndDate)
                ]);
                this.unapproveFormGroup.controls['dateRange'].patchValue([
                    new Date(this.user.UserEntryStartDate),
                    new Date(this.user.UserEntryEndDate)
                ]);
                this.unvalidateFormGroup.controls['dateRange'].patchValue([
                    new Date(this.user.UserEntryStartDate),
                    new Date(this.user.UserEntryEndDate)
                ]);
                this.mgmtDateRangeStart = moment(
                    this.user.UserEntryStartDate
                ).format('MM/DD/YYYY');
                this.mgmtDateRangeEnd = moment(
                    this.user.UserEntryEndDate
                ).format('MM/DD/YYYY');
                this.fullDateRangeSelected = true;
                this.dr_panelExpanded = true;
            }
        }
    }
    onRowReorderHandler($event: { dragIndex: number; dropIndex: number }) {
        // TODO: save everything after the drop index
        const start = Math.min($event.dragIndex, $event.dropIndex);
        const stop = Math.max($event.dragIndex, $event.dropIndex);
        this.log.verbose({
            type: 'TimecardPresenterComponent:onRowReorderHandler',
            $event,
            start,
            stop,
            items: this.timecardSequence
        });
        this.timecardSequence.splice($event.dropIndex, 0);
        for (let i = start; i <= this.timecardSequence.length - 1; i++) {
            this.timecardSequence[i] = {
                ...this.timecardSequence[i],
                Tasksortorder: i
            };
        }
        this.timecardSequence.slice(start, stop);
        this.timecardSequence.forEach(task => {
            if (+task.Tasksortorder <= stop) {
                this.SaveTimecardSequence.next(task);
            }
        });
    }
    reOrderTasksHidden() {
        const firstDate = this.sortedByTask[0].Day0.WorkDate.toString();
        this.pivot = true;
        this.dRSelectedSubject.next(this.sortedByTask[0].Day0);
    }
    documentationHidden() {
        if (this.hasStagedTimecardEdits()) {
            return;
        }
        this.store.dispatch(
            fromTimecard.getTimeCards({
                EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
                TimeCardDate: moment(this.sortedByTask[0].Day0.WorkDate).format(
                    'MM/DD/YYYY'
                ),
                MyDirection: ''
            })
        );
    }

    /** Staged Save-mode edits: refresh/sign would replace the grid with server data and drop them. */
    private hasStagedTimecardEdits(): boolean {
        return (
            !this.saveOnCellBlur &&
            (this.hasUnsavedChanges || this.pendingTimeCardUpdates.size > 0)
        );
    }

    /** Save-mode staged edits: block sign, document, and doc close refresh. */
    get stagedEditsBlockSignAndDocument(): boolean {
        return this.hasStagedTimecardEdits();
    }

    private discardStagedTimecardEdits(): void {
        this.pendingTimeCardUpdates.clear();
        this.pendingOriginalHours.clear();
        this.requiredCommentEntries = [];
        this.bulkCommentMsgs = [];
        this.bulkCommentActiveTabIndex = 0;
        this.displayBulkCommentPopup = false;
        this.setHasUnsavedChanges(false);
    }

    private confirmLeaveUnsavedTimeEntries(onLeave: () => void): void {
        this.confirmservice
            .confirmPromise({
                dialogText:
                    'You have unsaved time entries. Select Leave to DISCARD changes or Stay to continue editing.',
                okText: 'Leave',
                cancelText: 'Stay'
            })
            .then(() => {
                this.discardStagedTimecardEdits();
                onLeave();
            })
            .catch(() => Promise.reject(new Error('User chose to stay')));
    }

    documentTimeToolbarClicked(): void {
        if (this.hasStagedTimecardEdits()) {
            void this.confirmservice
                .confirmPromise({
                    dialogText:
                        'Timecard Documentation cannot be opened with unsaved changes in the timecard.',
                    okText: 'OK',
                    showCancel: false,
                })
                .then(() => undefined)
                .catch(() => undefined);
            return;
        }
        this.AddDocumentation.next(null);
    }
    onSave(doc: TimeCardDocumentation) {
        this.log.verbose({
            type: 'TimecardPresenterComponent:onSave',
            doc
        });
        if (doc) {
            const timecardCell = this.timecardData.find(
                x => x.EmpTimeID == doc.EmpTimeID
            );
            if (timecardCell) {
                if (doc?.Totalhours != null) {
                    if (+timecardCell.EmployeeHours >= +doc?.Totalhours) {
                        this.displayDocWarning = false;
                    } else {
                        this.displayDocWarning = true;
                    }
                }
            }
            if (doc?.Totalhours != null) {
                const empAuthID = doc.EmpAuthID ?? timecardCell?.EmpAuthID;
                if (empAuthID != null) {
                    const totalDocumentedHours =
                        this.getDocumentedHoursForEmpAuth(empAuthID);
                    this.timecardData.forEach(tc => {
                        if (tc.EmpAuthID === empAuthID) {
                            tc.TotalDocumentedHours = totalDocumentedHours;
                        }
                    });
                    const taskRow = this.sortedByTask.find(
                        x => x.empAuthID === empAuthID
                    );
                    if (taskRow) {
                        taskRow.TotalDocumentedHours = totalDocumentedHours;
                    }
                    if (this.tabTimeCard) {
                        this.tabTimeCard.updateData([
                            {
                                empAuthID,
                                TotalDocumentedHours: totalDocumentedHours
                            }
                        ]);
                    }
                }
            }
        }
    }
    ngAfterViewInit() {
        this.setupControlSubscriptions();
        setTimeout(this.afterViewInitAsync.bind(this), 0);
    }
    afterViewInitAsync() {
        if (this.isTaskManager || this.isSupervisor || this.isSuperUser) {
            this.timecardHeader = `TimeCard`;
            this.weeklySummaryHeader = `Weekly View`;
            this.createTabulatorForTimeCard(this, [], ['']);
            this.createTabulatorForWeeklySummary(this, [], ['']);
            if (this.isSupervisor == true || this.isTaskManager == true) {
                this.tc_panelExpanded = true;
            } else {
                this.tc_panelExpanded = false;
            }

            this.dr_panelExpanded = true;
        } else {
            if (this.accountNumber !== '') {
                this.weeklySummaryHeader =
                    'Weekly View' +
                    '\xa0\xa0' +
                    this.employeeName +
                    '\xa0\xa0' +
                    this.userEntryStartDate +
                    '\xa0' +
                    '-' +
                    '\xa0' +
                    this.userEntryEndDate;
            } else {
                this.weeklySummaryHeader =
                    'Weekly View' +
                    '\xa0\xa0' +
                    this.employeeName +
                    '\xa0\xa0' +
                    this.userEntryStartDate +
                    '\xa0' +
                    '-' +
                    '\xa0' +
                    this.userEntryEndDate;
            }

            this.tc_panelExpanded = true;
            //this.createTabulatorForWeeklySummary(this, [], ['']);
        }
        if (this.isUser === false && this.isSuperUser === false) {
            //this.tabActions.activeIndex = 0;
            //this.tabChange(this.tabActions);
            // this.log.debug({
            //     type: 'TimeCardPresenterComponent:ngAfterViewInit',
            //     tabView: this.tabActions
            // });
        }

        if (this.isUser === false || this.isSuperUser === false) {
            this.DRSubject.pipe(takeWhile(() => this.active)).subscribe(x => {

                if (this.mgmtActionInProgress == true) {

                    this.showManagementActionCompleteMsg = true;
                    if (this.managementActionResp.StatusCode == 1) {
                        setTimeout(() => {
                            this.showManagementActionCompleteMsg = false;
                        }, 5000);
                        this.mgmtActionInProgress = false;
                    } else {
                        this.mgmtActionInProgress = false;
                    }

                }
                // this.createTabulatorForManagementUsers(this, x, ['']);

                // if (this.isDRSelected === false && x.length > 0) {
                //     this.selectInitialDR();
                // }
            });
        }
    }
    /** Single period change path for the manager command bar (replaces per-tab date pickers). */
    private applyMgmtPeriod(
        start: Date,
        end: Date,
        mode: 'approval' | 'validate'
    ) {
        if (!start || !end) {
            return;
        }
        this.actionDateChosen(start, end);
        this.pivot = true;
        this.IsDateSelected = true;
        this.mgmtDateRangeStart = moment(start).format('MM/DD/YYYY');
        this.mgmtDateRangeEnd = moment(end).format('MM/DD/YYYY');
        sessionStorage.setItem('mgmtEndDate', String(end));
        this.managementActionEndDate = this.mgmtDateRangeEnd;
        this.directReportHeader = `Direct Reports | ${this.mgmtDateRangeStart} - ${this.mgmtDateRangeEnd}`;
        this.weeklySummaryHeader =
            mode === 'approval'
                ? 'Weekly Summary for Approval Period'
                : 'Weekly Summary for Validate Period';

        const range = [start, end];
        const opts = { emitEvent: false };
        this.approveFormGroup.controls['dateRange'].setValue(range, opts);
        this.disapproveFormGroup.controls['dateRange'].setValue(range, opts);
        this.unapproveFormGroup.controls['dateRange'].setValue(range, opts);
        this.validateFormGroup.controls['dateRange'].setValue(range, opts);
        this.disapproveValidateFormGroup.controls['dateRange'].setValue(
            range,
            opts
        );
        this.unvalidateFormGroup.controls['dateRange'].setValue(range, opts);

        if (this.directReportListID) {
            this.LoadMgmtLoadTimecardandWeeklySummary.next({
                EmployeeListID: this.directReportListID,
                StartDate: start,
                EndDate: end
            });
        }
    }

    get mgmtPeriodFormGroup(): UntypedFormGroup {
        return this.isTaskManager
            ? this.validateFormGroup
            : this.approveFormGroup;
    }

    setupControlSubscriptions() {
        this.approveFormGroup.controls['dateRange'].valueChanges
            .pipe(
                takeWhile(_ => this.active),
                filter(() => this.isSupervisor)
            )
            .subscribe(value => {
                if (value?.[0] && value?.[1]) {
                    this.applyMgmtPeriod(value[0], value[1], 'approval');
                }
            });

        this.validateFormGroup.controls['dateRange'].valueChanges
            .pipe(
                takeWhile(_ => this.active),
                filter(() => this.isTaskManager)
            )
            .subscribe(value => {
                if (value?.[0] && value?.[1]) {
                    this.applyMgmtPeriod(value[0], value[1], 'validate');
                }
            });

        this.filterFormGroup.controls['tasks'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.filterData(value, 'task', 'TaskLongName');
            });

        this.filterFormGroup.controls['directReports'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(directReports => {
                if (directReports != null) {
                    this.pivot = true;
                    this.dRSelectedSubject.next(directReports);
                    setTimeout(() => {
                        this.employeeName = directReports.EmployeeName;
                        this.detailsLabel = `HR Details for ${this.employeeName}`;
                        this.timecardDocHeader = `Timecard Documentation for ${this.employeeName}`;
                        this.drdropdown = true;
                        this.isDRSelected = true;
                        this.tc_panelExpanded = true;

                        this.selectedDR = this.directReports.find(
                            x =>
                                x.EmployeeListID ===
                                directReports.EmployeeListID.toString()
                        );
                        if (directReports.AccountNumber != null) {
                            this.weeklySummaryHeader =
                                'Weekly View' +
                                '\xa0\xa0' +
                                directReports.EmployeeName +
                                '\xa0\xa0' +
                                moment(directReports.MinWorkDate).format(
                                    'MM/DD/YYYY'
                                ) +
                                '\xa0' +
                                '-' +
                                '\xa0' +
                                moment(directReports.MaxWorkDate).format(
                                    'MM/DD/YYYY'
                                );
                        } else {
                            this.weeklySummaryHeader =
                                'Weekly View' +
                                '\xa0\xa0' +
                                directReports.EmployeeName +
                                '\xa0\xa0' +
                                moment(directReports.MinWorkDate).format(
                                    'MM/DD/YYYY'
                                ) +
                                '\xa0' +
                                '-' +
                                '\xa0' +
                                moment(directReports.MaxWorkDate).format(
                                    'MM/DD/YYYY'
                                );
                        }
                        this.filterFormGroup.controls['tasks'].reset();
                        this.updateTasks.emit(directReports);
                        this.directReportListID = directReports.EmployeeListID;
                    }, 0);
                }
            });
    }
    ngOnDestroy() {
        this.store.dispatch(fromTimecard.clearTimeCards());
        this.store.dispatch(fromWeeklySummary.clearWeeklySummarys());
        this.store.dispatch(fromDRWTS.clearDirectReportsWithTimeStatuss());
        this.active = false;
        this.drdropdown = false;
        this.setHasUnsavedChanges(false);
    }

    private setHasUnsavedChanges(hasUnsaved: boolean): void {
        this.hasUnsavedChanges = hasUnsaved;
        this.timecardUnsavedStateService.setHasPendingTimecardChanges(hasUnsaved);
    }

    getTimecardSequence() {
        this.displayReorderTasks = true;
        this.LoadTimecardSequence.next();
    }

    showMyDRsChecked(event) {
        this.showMyDRs = event.checked;
        this.LoadDirectReportsWithTimeStatus.next(
            {
                MyDRsOnly: event.checked,
                startDate: this.mgmtDateRangeStart,
                endDate: this.mgmtDateRangeEnd
            }
        );
    }

    trackDirectReport = (index: number, report: IDirectReportsWithTimeStatus) =>
        report.EmployeeListID;

    onDirectReportCardToggle(report: IDirectReportsWithTimeStatus) {
        const nextExpanded =
            this.expandedDirectReportId === report.EmployeeListID
                ? undefined
                : report.EmployeeListID;
        this.expandedDirectReportId = nextExpanded;
    }

    onDirectReportSelect(report: IDirectReportsWithTimeStatus) {
        this.setSelectedDirectReport(report, true);
    }

    private get isApprovalOrValidationView(): boolean {
        return (this.isSupervisor || this.isTaskManager) && !this.isSuperUser;
    }

    private get timecardMaxHeightVh(): number {
        if (this.isApprovalOrValidationView) {
            return 33;
        }
        if (this.isSuperUser) {
            return 50;
        }
        return 50;
    }

    onWeeklySummaryToggle(event?: { collapsed?: boolean }) {
        if (event && typeof event.collapsed === 'boolean') {
            this.weeklySummaryCollapsed = event.collapsed;
        }
        setTimeout(() => {
            this.adjustTimecardHeightForWeeklySummary();
        }, 0);
    }

    private adjustTimecardHeightForWeeklySummary() {
        // Keep timecard height fixed when weekly summary toggles.
        return;
        if (!this.weeklySummaryPanel?.nativeElement || !this.tabTimeCard) {
            return;
        }
        const panelEl = this.weeklySummaryPanel.nativeElement as HTMLElement;
        const panelHeight = panelEl.offsetHeight;
        if (this.weeklySummaryCollapsed) {
            this.weeklySummaryCollapsedHeight = panelHeight;
        } else {
            this.weeklySummaryExpandedHeight = panelHeight;
        }
        const tableEl = document.getElementById('tabTimeCard');
        if (!tableEl) {
            return;
        }
        if (this.timecardBaseHeightPx == null) {
            const dynamicHeight = String(this.dynamicTableHeight || '');
            const vhMatch = dynamicHeight.match(/^(\d+(?:\.\d+)?)vh$/);
            if (vhMatch) {
                this.timecardBaseHeightPx = Math.round(
                    (window.innerHeight * Number(vhMatch[1])) / 100
                );
            } else {
                this.timecardBaseHeightPx = tableEl.offsetHeight;
            }
        }
        const delta = Math.max(
            0,
            this.weeklySummaryExpandedHeight - this.weeklySummaryCollapsedHeight
        );
        const maxVh = this.timecardMaxHeightVh;
        const maxHeightPx = Math.round((window.innerHeight * maxVh) / 100);
        if (this.isSuperUser) {
            this.timecardBaseHeightPx = maxHeightPx;
        }
        const nextHeight = this.weeklySummaryCollapsed
            ? this.timecardBaseHeightPx + delta
            : Math.max(120, this.timecardBaseHeightPx - delta);
        const clampedHeight = Math.min(maxHeightPx, nextHeight);
        const roundedHeight = Math.round(clampedHeight);
        if (this.lastAppliedTimecardHeightPx === roundedHeight) {
            return;
        }
        this.lastAppliedTimecardHeightPx = roundedHeight;
        this.tabTimeCard.setHeight(`${roundedHeight}px`);
    }

    isDirectReportExpanded(report: IDirectReportsWithTimeStatus): boolean {
        return this.expandedDirectReportId === report.EmployeeListID;
    }

    isDirectReportSelected(report: IDirectReportsWithTimeStatus): boolean {
        return this.selectedDirectReports?.some(
            selected => selected.EmployeeListID === report.EmployeeListID
        );
    }

    get filteredDirectReports(): Array<IDirectReportsWithTimeStatus> {
        const search = (this.directReportSearchTerm || '').trim().toLowerCase();
        const reports = (this.directReportTimeStatusData ?? []).filter(report =>
            search
                ? String(report.UserName ?? '')
                      .toLowerCase()
                      .includes(search)
                : true
        );
        return this.sortDirectReports(reports);
    }

    private sortDirectReports(
        reports: Array<IDirectReportsWithTimeStatus>
    ): Array<IDirectReportsWithTimeStatus> {
        const sortBy = this.directReportSortBy || 'name';
        const sorted = [...reports];
        if (sortBy === 'name') {
            return sorted.sort((a, b) => this.compareDirectReportNames(a, b));
        }
        return sorted.sort((a, b) => {
            const aValue = this.getDirectReportStatusValue(a, sortBy);
            const bValue = this.getDirectReportStatusValue(b, sortBy);
            if (bValue !== aValue) {
                return bValue - aValue;
            }
            return this.compareDirectReportNames(a, b);
        });
    }

    private getDirectReportStatusValue(
        report: IDirectReportsWithTimeStatus,
        sortBy: string
    ): number {
        switch (sortBy) {
            case 'Signed':
                return Number(report.Signed ?? 0);
            case 'Saved':
                return Number(report.Saved ?? 0);
            case 'Approved':
                return Number(report.Approved ?? 0);
            case 'Validated':
                return Number(report.Validated ?? 0);
            case 'Disapproved':
                return Number(report.Disapproved ?? 0);
            case 'Documented':
                return Number(report.Documented ?? 0);
            default:
                return 0;
        }
    }

    private compareDirectReportNames(
        a: IDirectReportsWithTimeStatus,
        b: IDirectReportsWithTimeStatus
    ): number {
        return String(a.UserName ?? '').localeCompare(
            String(b.UserName ?? ''),
            undefined,
            { sensitivity: 'base' }
        );
    }

    isAllDirectReportsSelected(): boolean {
        const reports = this.filteredDirectReports;
        if (!reports?.length) {
            return false;
        }
        return reports.every(report =>
            this.isDirectReportSelected(report)
        );
    }

    toggleSelectAllDirectReports() {
        const reports = this.filteredDirectReports;
        if (!reports?.length) {
            return;
        }
        if (this.isAllDirectReportsSelected()) {
            const selectedIds = new Set(
                reports.map(report => report.EmployeeListID)
            );
            this.selectedDirectReports = this.selectedDirectReports.filter(
                selected => !selectedIds.has(selected.EmployeeListID)
            );
        } else {
            const existingIds = new Set(
                this.selectedDirectReports.map(selected => selected.EmployeeListID)
            );
            const merged = [...this.selectedDirectReports];
            reports.forEach(report => {
                if (!existingIds.has(report.EmployeeListID)) {
                    merged.push({
                        EmployeeListID: report.EmployeeListID,
                        EmployeeName: report.UserName ?? 'na',
                        IsActive: 1
                    });
                }
            });
            this.selectedDirectReports = merged;
        }
        this.updateDirectReportSelectionState();
    }

    onDirectReportSelectionChange(
        report: IDirectReportsWithTimeStatus,
        event
    ) {
        const checked = event?.checked === true;
        if (checked && !this.isDirectReportSelected(report)) {
            this.selectedDirectReports = [
                ...this.selectedDirectReports,
                {
                    EmployeeListID: report.EmployeeListID,
                    EmployeeName: 'na',
                    IsActive: 1
                }
            ];
        } else {
            this.selectedDirectReports = this.selectedDirectReports.filter(
                selected => selected.EmployeeListID !== report.EmployeeListID
            );
        }
        this.updateDirectReportSelectionState();
    }

    private updateDirectReportSelectionState() {
        if (this.fullDateRangeSelected && this.selectedDirectReports.length > 0) {
            this.IsDisabled = false;
        }
        if (this.selectedDirectReports.length === 0) {
            this.IsDisabled = true;
        }
    }

    getStatusStyle(status: string): { [key: string]: string } {
        const color = this.userWebColors?.find(x => x.Status === status);
        if (!color) {
            return {};
        }
        const isSelected = this.isStatusSelected(status);
        // Saved status: use forecolor for border when not selected (approval/validation direct report cards)
        const borderColor = (status === 'Saved' && !isSelected) ? color.Forecolor_Hex : color.Backcolor_hex;

        if (isSelected) {
            return {
                'background-color': color.Backcolor_hex,
                'border': 'none'
            };
        }

        return {
            'border-color': borderColor
        };
    }

    getStatusLabelStyle(status: string): { [key: string]: string } {
        const color = this.userWebColors?.find(x => x.Status === status);
        if (!color) {
            return {};
        }
        const isSelected = this.isStatusSelected(status);

        if (isSelected) {
            return {
                'color': color.Forecolor_Hex
            };
        }

        // Saved status uses forecolor in approval/validation direct report cards
        const labelColor = status === 'Saved' ? color.Forecolor_Hex : color.Backcolor_hex;
        return {
            'color': labelColor
        };
    }

    getStatusHoursStyle(status: string): { [key: string]: string } {
        const color = this.userWebColors?.find(x => x.Status === status);
        if (!color) {
            return {};
        }
        const isSelected = this.isStatusSelected(status);

        if (isSelected) {
            return {
                'color': color.Forecolor_Hex
            };
        }

        return {
            'color': 'var(--text-color)'
        };
    }

    isStatusSelected(status: string): boolean {
        return this.directReportSortBy === status;
    }

    formatStatusValue(value: number): string {
        if (value === null || value === undefined || value === ('' as any)) {
            return '—';
        }
        return `${value}`;
    }

    formatDirectReportDate(value: string): string {
        if (!value) {
            return '—';
        }
        return moment(value).isValid()
            ? moment(value).format('MM/DD/YYYY')
            : value;
    }

    getCurrentEntryPeriod(report?: IDirectReportsWithTimeStatus): string {
        if (this.userEntryStartDate && this.userEntryEndDate) {
            return `${this.userEntryStartDate} - ${this.userEntryEndDate}`;
        }
        if (report?.WebEntryPeriod) {
            return report.WebEntryPeriod;
        }
        return '—';
    }

    shouldShowValidated(): boolean {
        return !!this.userWebColors?.find(x => x.Status === 'Validated');
    }

    private getSelectedDirectReportData(): IDirectReportsWithTimeStatus | null {
        if (this.selectedDirectReport) {
            return this.selectedDirectReport;
        }
        if (this.selectedDRRow && this.selectedDRRow.getData) {
            return this.selectedDRRow.getData();
        }
        return null;
    }

    private setSelectedDirectReport(
        report: IDirectReportsWithTimeStatus,
        emitSelection: boolean
    ) {
        this.isDRSelected = true;
        this.DRName = report.UserName;
        this.directReportListID = report.EmployeeListID;
        this.selectedDirectReport = report;
        this.selectedDirectReportId = report.EmployeeListID;
        this.selectedDRRow = {
            getData: () => report
        };
        this.detailsLabel = `HR Details for ${report.UserName}`;
        // emitSelection=false is a DR-list refresh of the same selection (e.g. after a
        // management action). Only clear/reload the timecard when the user picks a DR.
        if (emitSelection) {
            this.pivot = true;
            this.prevButtonHidden = false;
            this.nextButtonHidden = false;
            this.displayDocWarning = false;
            this.displayOver24HoursWarning = false;
            this.dRSelectedSubject.next(report);
            if (this.tabTimeCard) {
                this.tabTimeCard.clearData();
            }
        }
        if (this.managementActionEndDate == null) {
            this.managementActionEndDate = moment(new Date()).format(
                'MM/DD/YYYY'
            );
        }
        if (this.isSupervisor) {
            this.weeklySummaryHeader =
                'Weekly Summary for Approval Period';
        } else if (this.isTaskManager) {
            this.weeklySummaryHeader =
                'Weekly Summary for Validate Period';
        } else {
            this.weeklySummaryHeader =
                'Weekly View' +
                '\xa0\xa0' +
                report.UserName +
                '\xa0\xa0' +
                report.WebEntryPeriod;
        }
    }

    selectInitialDR() {
        if (this.isTaskManager || this.isSupervisor) {
            const report = this.directReportTimeStatusData[0];
            if (report) {
                this.expandedDirectReportId = this.isSupervisor
                    ? undefined
                    : report.EmployeeListID;
                this.setSelectedDirectReport(report, true);
            }
        }
    }

    showDeleteHoursPopup() {
        this.displayDeleteWarningPopup = true;
    }

    confirmBtnClickedForDelete() {
        this.displayDeleteWarningPopup = false;
        const row = this.currentCell.getRow();
        const status = this.currentCell.getValue();
        const rowdata = row.getData();
        const oldData = this.timecardData.find(
            x =>
                x.EmpAuthID === rowdata.empAuthID &&
                x.WorkDate === rowdata[this.currentDay].WorkDate
        );

        // Debug logging
        console.log('confirmBtnClickedForDelete - Debug Info:');
        console.log('Current EmployeeHours:', rowdata[this.currentDay].EmployeeHours);
        console.log('Old EmployeeHours (from timecardData):', oldData ? oldData.EmployeeHours : 'No oldData found');
        console.log('Cell getOldValue():', this.currentCell.getOldValue());
        console.log('Current day:', this.currentDay);
        console.log('Cell getValue():', this.currentCell.getValue());
        console.log('Full rowdata for this day:', rowdata[this.currentDay]);

        // The correct value to revert to should be the cell's old value (what was there before clearing)
        // OR if that's not available, use the saved value from the current rowdata
        let revertValue = null;

        // First try to get the cell's old value (what user had before clearing)
        const cellOldValue = this.currentCell.getOldValue();
        console.log('cellOldValue type:', typeof cellOldValue, 'value:', cellOldValue);

        if (cellOldValue != null && cellOldValue !== '' && cellOldValue !== undefined) {
            revertValue = cellOldValue;
            console.log('Using cell old value for revert:', revertValue);
        } else {
            // If cell old value is not available, try to find the most recent saved value
            console.log('cellOldValue not usable, checking rowdata EmployeeHours...');
            const currentEmployeeHours = rowdata[this.currentDay].EmployeeHours;
            console.log('currentEmployeeHours type:', typeof currentEmployeeHours, 'value:', currentEmployeeHours);

            // Since the console shows the EmployeeHours is 0, let's check if there was a recent edit
            // that hasn't been saved yet. Sometimes the value is in the Tabulator data structure
            // but not reflected in the current rowdata

            // Try to get the value from Tabulator's internal data
            const cellData = this.currentCell.getElement();
            const cellValueFromDOM = cellData ? cellData.textContent : null;
            console.log('Cell DOM content:', cellValueFromDOM);

            // Check if the current day's data structure has any hints about the previous value
            console.log('Checking for any non-zero/non-null values in the day data...');
            const dayData = rowdata[this.currentDay];

            // Sometimes the value might be stored in a different property temporarily
            Object.keys(dayData).forEach(key => {
                if (key.includes('Hours') || key.includes('Value')) {
                    console.log(`${key}:`, dayData[key]);
                }
            });

            if (currentEmployeeHours != null && currentEmployeeHours !== 0 && currentEmployeeHours !== '' && currentEmployeeHours !== undefined) {
                revertValue = currentEmployeeHours;
                console.log('Using current rowdata EmployeeHours for revert:', revertValue);
            } else {
                // Try the timecardData as the source of truth for saved values
                if (oldData && oldData.EmployeeHours != null && oldData.EmployeeHours !== 0) {
                    revertValue = oldData.EmployeeHours;
                    console.log('Using timecardData value for revert:', revertValue);
                } else {
                    console.log('No valid value found in timecardData either');

                    // Last resort: check if we can find any numeric value that was recently entered
                    // This is a fallback for when the normal tracking fails
                    console.log('Attempting last resort value recovery...');

                    // If the user scenario is: enter value -> tab -> come back -> clear -> the popup should revert
                    // But the value isn't being tracked properly, we might need to store it ourselves
                    // For now, let's see if there's any trace of the entered value
                }
            }
        }

        console.log('Final revert value determination:', revertValue, 'type:', typeof revertValue);

        // If we have a value to revert to, do the reversion
        if (revertValue != null && revertValue !== 0 && revertValue !== '' && revertValue !== undefined) {
            console.log('PERFORMING REVERT TO VALUE:', revertValue);
            // Use the row update method to properly refresh the cell display
            row.update({
                [this.currentDay]: {
                    InterfaceType: rowdata[this.currentDay].InterfaceType,
                    TimerCreate: rowdata[this.currentDay].TimerCreate,
                    ChangeComment: rowdata[this.currentDay].ChangeComment,
                    CreateDate: rowdata[this.currentDay].CreateDate,
                    DateLastModified: rowdata[this.currentDay].DateLastModified,
                    CurrentUserListID: rowdata[this.currentDay].CurrentUserListID,
                    DailyTotal: rowdata[this.currentDay].DailyTotal,
                    DateColor: rowdata[this.currentDay].DateColor,
                    DatePurpose: rowdata[this.currentDay].DatePurpose,
                    Deletedoc: rowdata[this.currentDay].Deletedoc,
                    EmpAuthEndDate: rowdata[this.currentDay].EmpAuthEndDate,
                    EmpAuthID: rowdata[this.currentDay].EmpAuthID,
                    EmpAuthStartDate: rowdata[this.currentDay].EmpAuthStartDate,
                    EmpAuthURL: rowdata[this.currentDay].EmpAuthURL,
                    EmpTimeID: rowdata[this.currentDay].EmpTimeID,
                    EmployeeHours: revertValue, // Revert to determined value
                    EmployeeListID: rowdata[this.currentDay].EmployeeListID,
                    IsReadOnly: rowdata[this.currentDay].IsReadOnly,
                    IsTimeClockTime: rowdata[this.currentDay].IsTimeClockTime,
                    LeaveAccrualInfo: rowdata[this.currentDay].LeaveAccrualInfo,
                    LeavePayout: rowdata[this.currentDay].LeavePayout,
                    LeavePayoutWeek: rowdata[this.currentDay].LeavePayoutWeek,
                    NbrOfRows: rowdata[this.currentDay].NbrOfRows,
                    OutOfDateRange: rowdata[this.currentDay].OutOfDateRange,
                    PayrollItem: rowdata[this.currentDay].PayrollItem,
                    PeriodHasSplitDay: rowdata[this.currentDay].PeriodHasSplitDay,
                    ReadOnlyReason: rowdata[this.currentDay].ReadOnlyReason,
                    Row_Version: rowdata[this.currentDay].Row_Version,
                    ServiceItem: rowdata[this.currentDay].ServiceItem,
                    SplitWorkDate: rowdata[this.currentDay].SplitWorkDate,
                    Status: rowdata[this.currentDay].Status,
                    TaskDisplay: rowdata[this.currentDay].TaskDisplay,
                    TaskLongName: rowdata[this.currentDay].TaskLongName,
                    TimeStatus: rowdata[this.currentDay].TimeStatus,
                    WeeklyTotal: rowdata[this.currentDay].WeeklyTotal,
                    WorkDate: rowdata[this.currentDay].WorkDate,
                    WorkDateHdr: rowdata[this.currentDay].WorkDateHdr,
                    WorkDocumentedCount: rowdata[this.currentDay].WorkDocumentedCount,
                    Backcolor_hex: rowdata[this.currentDay].Backcolor_hex,
                    Forecolor_hex: rowdata[this.currentDay].Forecolor_hex
                }
            });

            // Also try to set the cell value directly as a backup
            console.log('Also setting cell value directly to:', revertValue);
            this.currentCell.setValue(revertValue);

        } else {
            console.log('No valid revert value found or value is 0/empty - allowing deletion. RevertValue was:', revertValue);
            // No valid revert value, leave the cell empty or proceed with normal deletion logic
        }

        this.refreshOver24HoursWarning();
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    showDisplayNotePopup() {
        this.displayNotePopup = true;
    }

    discardBtnClicked() {
        this.displayNotePopup = false;
        const row = this.currentCell.getRow();
        const status = this.currentCell.getValue();
        const rowdata = row.getData();
        this.revertRowToPreviousValue(this.currentCell);
    }

    confirmBtnClicked() {
        if (this.changeMessage !== '') {
            this.confirmMessage().then(() => {
                this.confirmTimeChangeWithMessage();
            });
        } else {
            this.msgs = [];
            this.msgs.push({
                severity: 'error',
                summary: 'Error',
                detail: 'Reason is required.'
            });
        }
    }

    confirmMessage() {
        return new Promise<void>((resolve, reject) => {
            this.log.verbose(`message: ${this.changeMessage}`);
            this.displayNotePopup = false;
            resolve();
        });
    }

    confirmTimeChangeWithMessage() {
        const value = this.currentCell.getValue();
        if (this.changeMessage !== '') {
            const rowdata = this.currentRow.getData();
            rowdata[this.currentDay].ChangeComment = this.changeMessage;
            rowdata[this.currentDay].EmployeeHours =
                this.currentCell.getValue();
            this.signaturePolicyCheck(this.currentCell);
        }
        this.changeMessage = '';
    }

    cancelBulkCommentDialog(): void {
        this.displayBulkCommentPopup = false;
        this.bulkCommentMsgs = [];
        this.bulkCommentActiveTabIndex = 0;
    }

    applyActiveCommentToAllRequiredEntries(): void {
        const activeEntry = this.requiredCommentEntries[this.bulkCommentActiveTabIndex];
        const comment = (activeEntry?.comment || '').trim();

        if (!comment) {
            this.bulkCommentMsgs = [
                {
                    severity: 'error',
                    summary: 'Error',
                    detail:
                        'Enter a reason in the current tab before applying it to all entries.'
                }
            ];
            return;
        }

        this.requiredCommentEntries = this.requiredCommentEntries.map(entry => ({
            ...entry,
            comment
        }));
        this.bulkCommentMsgs = [];
    }

    get shouldScrollBulkCommentTabs(): boolean {
        return this.requiredCommentEntries.length >= 4;
    }

    confirmBulkCommentsAndSave(): void {
        const firstMissing = this.requiredCommentEntries.findIndex(
            entry => !entry.comment || entry.comment.trim() === ''
        );

        if (firstMissing !== -1) {
            this.bulkCommentMsgs = [
                {
                    severity: 'error',
                    summary: 'Error',
                    detail:
                        'A reason is required for each changed time entry before saving.'
                }
            ];
            return;
        }

        this.requiredCommentEntries.forEach(entry => {
            const pending = this.pendingTimeCardUpdates.get(entry.key);
            if (pending) {
                pending.ChangeComment = entry.comment.trim();
                this.pendingTimeCardUpdates.set(entry.key, pending);
            }
        });

        this.bulkCommentMsgs = [];
        this.displayBulkCommentPopup = false;
        this.saveAllPending();
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    showPolicyPopup() {
        this.displayPolicyPopup = true;
    }

    cancelBtnClicked() {
        this.displayPolicyPopup = false;
        this.showSignaturePolicyError = false;
        this.pswdForSig = null;
        this.revertRowToPreviousValue(this.currentCell);
    }

    confirmPolicyClicked() { //4921
        if (this.pswdForSig != null) {
            this.showSignaturePolicyError = false;
            this.timePolicyCbxChecked = false;
            this.LoadSignaturePolicy.next(this.pswdForSig);
            setTimeout(() => {
                if (this.signaturePolicy != null) {
                    if (this.signaturePolicy[0][0].Validated == true) {
                        this.showSignaturePolicy = false;
                        this.displayPolicyPopup = false;

                        if (this.signaturePolicyRequired === true && this.requireTimeSubmit == true) {
                            if (this.signWeek == true) {
                                this.timeCardSubmit([
                                    {
                                        EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
                                        TimeCardStatus: '1',
                                        StartDate: this.sortedByTask[0].Day0.WorkDate,
                                        EndDate: this.findLastDayInWeek()
                                    }
                                ]);
                                this.signWeek = false;
                            }
                            if (this.signPeriod == true) {
                                this.timeCardSubmit([
                                    {
                                        EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
                                        TimeCardStatus: '1',
                                        StartDate: '',
                                        EndDate: ''
                                    }
                                ]);
                                this.signPeriod = false;
                            }

                        } else {
                            this.timeCardUpdate.emit([
                                this.getTimecardDay(this.currentCell)
                            ]);
                            this.setCreateDateAfterSave(this.currentCell);
                        }

                        this.userStore.dispatch(
                            new SetSignaturePolicy({
                                ...this.user,
                                ShowSignaturePolicy: false
                            })
                        );
                        this.pswdForSig = null;
                    } else {
                        this.showSignaturePolicyError = true;
                    }
                }
            }, 1500);
        } else {
            this.showSignaturePolicyError = true;
        }
    }

    passwordInputFocused() {
        this.showSignaturePolicyError = false;
    }

    actionDateChosen(start, end) {
        if (this.tabManagement) {
            this.tabManagement.clearData();
        }
        this.dr_panelExpanded = true;
        let role;
        if (this.isSupervisor) {
            role = 12024;
        } else if (this.isTaskManager) {
            role = 12025;
        } else {
            role = -1;
        }
        if (end == null) {
            end = moment(new Date()).format('MM/DD/YYYY');
        }
        // if (start === null) {
        //     this.actionDateSelected.emit({
        //         EndDate: moment(end).format('MM/DD/YYYY'),
        //         StartDate: null,
        //         Role: role
        //     });
        // } else {
        //     this.actionDateSelected.emit({
        //         EndDate: moment(end).format('MM/DD/YYYY'),
        //         StartDate: moment(start).format('MM/DD/YYYY'),
        //         Role: role
        //     });
        // }
        this.actionDateSelected.emit({
            EndDate: moment(end).format('MM/DD/YYYY'),
            StartDate: moment(start).format('MM/DD/YYYY'),
            Role: role,
            MyDRsOnly: this.showMyDRs
        });
    }

    filterData(filters: any[], fieldName: string, valueName: string) {
        this.tabTimeCard.clearFilter(true);

        const filtersToApply: Array<
            Array<{
                field: string;
                type: string;
                value: any;
            }>
        > = [[]];

        if (filters && filters.length > 0) {
            filters.forEach(v => {
                filtersToApply[0].push({
                    field: fieldName,
                    type: '=',
                    value: v[valueName]
                });
            });
        }

        this.tabTimeCard.setFilter(filtersToApply);
    }

    getProcessRole(processID: number, user: IUserInfo): UserRoleEnum {
        let roleId;
        switch (processID) {
            case 87:
                roleId = UserRoleEnum.TaskManager;
                break;
            case 85:
                roleId = UserRoleEnum.Supervisor;
                break;
            case 90:
                roleId = 'superUser';
                break;
            default:
                break;
        }
        return roleId;
    }

    setProcessRole(roleId) {
        if (roleId === 12024) {
            this.isSuperUser = false;
            this.isSupervisor = true;
            this.isTaskManager = false;
            this.isUser = false;
        } else if (roleId === 12025) {
            this.isSuperUser = false;
            this.isSupervisor = false;
            this.isTaskManager = true;
            this.isUser = false;
        } else if (roleId === 'superUser') {
            this.isSuperUser = true;
            this.isSupervisor = false;
            this.isTaskManager = false;
            this.isUser = false;
        } else {
            this.isSuperUser = false;
            this.isSupervisor = false;
            this.isTaskManager = false;
            this.isUser = true;
        }
    }

    transformDate(date) {
        return new DatePipe('en-US').transform(date, 'MM/dd/yyyy');
    }

    onActiveIndexChanged($event) {
        this.tabIndex = $event;
        if (this.isSupervisor) {
            if (this.tabIndex == 0) {
                } else if (this.tabIndex == 1) {
                } else if (this.tabIndex == 2) {
                }
        }
        if (this.isTaskManager) {
            if (this.tabIndex == 0) {
                } else if (this.tabIndex == 1) {
                } else if (this.tabIndex == 2) {
                }
        }
    }

    // tabChange(tabActions: TabView) {
    //     this.log.verbose({
    //         type: 'TimeCardPresenterComponent:tabChange',
    //         tab: tabActions
    //     });
    //     if (
    //         this.fullDateRangeSelected === true &&
    //         this.selectedDirectReports.length > 0
    //     ) {
    //         this.IsDisabled = false;
    //     } else {
    //         this.IsDisabled = true;
    //     }
    // }

    getLatestDate(arr) {
        let maxDate = arr[0],
            maxDateObj = new Date(arr[0]);
        arr.forEach((d, i) => {
            if (new Date(d) > maxDateObj) {
                maxDate = d;
                maxDateObj = new Date(d);
            }
        });
        return maxDate;
    }

    calculateWeeklyTotals(cell) {
        let weeklyTotal;
        const row = cell.getRow();
        const rowdata = row.getData();
        if (
            rowdata.Day0.EmployeeHours == null ||
            rowdata.Day1.EmployeeHours == null ||
            rowdata.Day2.EmployeeHours == null ||
            rowdata.Day3.EmployeeHours == null ||
            rowdata.Day4.EmployeeHours == null ||
            rowdata.Day5.EmployeeHours == null ||
            rowdata.Day6.EmployeeHours == null
        ) {
        }
        weeklyTotal =
            +rowdata.Day0.EmployeeHours +
            +rowdata.Day1.EmployeeHours +
            +rowdata.Day2.EmployeeHours +
            +rowdata.Day3.EmployeeHours +
            +rowdata.Day4.EmployeeHours +
            +rowdata.Day5.EmployeeHours +
            +rowdata.Day6.EmployeeHours;
        return weeklyTotal;
    }

    findLastDayInWeek() {
        let lastDayInWeek;
        if (
            this.hasProp(this.sortedByTask[0], 'Day7') &&
            this.hasProp(this.sortedByTask[0].Day7, 'WorkDate')
        ) {
            lastDayInWeek = this.sortedByTask[0].Day7.WorkDate;
        } else if (
            this.hasProp(this.sortedByTask[0], 'Day6') &&
            this.hasProp(this.sortedByTask[0].Day6, 'WorkDate')
        ) {
            lastDayInWeek = this.sortedByTask[0].Day6.WorkDate;
        } else if (
            this.hasProp(this.sortedByTask[0], 'Day5') &&
            this.hasProp(this.sortedByTask[0].Day5, 'WorkDate')
        ) {
            lastDayInWeek = this.sortedByTask[0].Day5.WorkDate;
        } else if (
            this.hasProp(this.sortedByTask[0], 'Day4') &&
            this.hasProp(this.sortedByTask[0].Day4, 'WorkDate')
        ) {
            lastDayInWeek = this.sortedByTask[0].Day4.WorkDate;
        } else if (
            this.hasProp(this.sortedByTask[0], 'Day3') &&
            this.hasProp(this.sortedByTask[0].Day3, 'WorkDate')
        ) {
            lastDayInWeek = this.sortedByTask[0].Day3.WorkDate;
        } else if (
            this.hasProp(this.sortedByTask[0], 'Day2') &&
            this.hasProp(this.sortedByTask[0].Day2, 'WorkDate')
        ) {
            lastDayInWeek = this.sortedByTask[0].Day2.WorkDate;
        } else if (
            this.hasProp(this.sortedByTask[0], 'Day1') &&
            this.hasProp(this.sortedByTask[0].Day1, 'WorkDate')
        ) {
            lastDayInWeek = this.sortedByTask[0].Day1.WorkDate;
        } else {
            lastDayInWeek = this.sortedByTask[0].Day0.WorkDate;
        }

        return lastDayInWeek;
    }

    /**
     * Get the WorkDateHdr of the last day in the week dynamically
     */
    get lastDayWorkDateHdr(): string {
        if (!this.sortedByTask || this.sortedByTask.length === 0) {
            return '';
        }

        // Check from Day7 down to Day0 to find the last available day
        if (this.hasProp(this.sortedByTask[0], 'Day7') && this.hasProp(this.sortedByTask[0].Day7, 'WorkDateHdr')) {
            return this.sortedByTask[0].Day7.WorkDateHdr;
        } else if (this.hasProp(this.sortedByTask[0], 'Day6') && this.hasProp(this.sortedByTask[0].Day6, 'WorkDateHdr')) {
            return this.sortedByTask[0].Day6.WorkDateHdr;
        } else if (this.hasProp(this.sortedByTask[0], 'Day5') && this.hasProp(this.sortedByTask[0].Day5, 'WorkDateHdr')) {
            return this.sortedByTask[0].Day5.WorkDateHdr;
        } else if (this.hasProp(this.sortedByTask[0], 'Day4') && this.hasProp(this.sortedByTask[0].Day4, 'WorkDateHdr')) {
            return this.sortedByTask[0].Day4.WorkDateHdr;
        } else if (this.hasProp(this.sortedByTask[0], 'Day3') && this.hasProp(this.sortedByTask[0].Day3, 'WorkDateHdr')) {
            return this.sortedByTask[0].Day3.WorkDateHdr;
        } else if (this.hasProp(this.sortedByTask[0], 'Day2') && this.hasProp(this.sortedByTask[0].Day2, 'WorkDateHdr')) {
            return this.sortedByTask[0].Day2.WorkDateHdr;
        } else if (this.hasProp(this.sortedByTask[0], 'Day1') && this.hasProp(this.sortedByTask[0].Day1, 'WorkDateHdr')) {
            return this.sortedByTask[0].Day1.WorkDateHdr;
        } else {
            return this.sortedByTask[0].Day0?.WorkDateHdr || '';
        }
    }

    requireTimeSubmitPeriodClicked() { //4921
        if (this.handlePendingSaveBeforeSubmit('period')) {
            return;
        }

        this.pivot = true;
        this.signPeriod = true;
        if (this.signaturePolicyRequired === true && this.requireTimeSubmit == true) {
            if (this.showSignaturePolicy === true) {
                this.showPolicyPopup();
            } else {
                this.timeCardSubmit([
                    {
                        EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
                        TimeCardStatus: '1',
                        StartDate: '',
                        EndDate: ''
                    }
                ]);
            }
        } else {
            this.timeCardSubmit([
                {
                    EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
                    TimeCardStatus: '1',
                    StartDate: '',
                    EndDate: ''
                }
            ]);
        }


        // this.store.dispatch(
        //     fromTimecard.getTimeCards({
        //         EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
        //         TimeCardDate: moment(new Date()).format('MM/DD/YYYY'),
        //         MyDirection: null
        //     })
        // );
        this.requireSubmitFlag = true;
    }

    requireTimeSubmitWeekClicked() { //4921
        if (this.handlePendingSaveBeforeSubmit('week')) {
            return;
        }

        this.pivot = true;
        this.signWeek = true;
        if (this.signaturePolicyRequired === true && this.requireTimeSubmit == true) {
            if (this.showSignaturePolicy === true) {
                this.showPolicyPopup();
            } else {
                this.timeCardSubmit([
                    {
                        EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
                        TimeCardStatus: '1',
                        StartDate: this.sortedByTask[0].Day0.WorkDate,
                        EndDate: this.findLastDayInWeek()
                    }
                ]);
            }
        } else {
            this.timeCardSubmit([
                {
                    EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
                    TimeCardStatus: '1',
                    StartDate: this.sortedByTask[0].Day0.WorkDate,
                    EndDate: this.findLastDayInWeek()
                }
            ]);
        }


        // this.store.dispatch(
        //     fromTimecard.getTimeCards({
        //         EmployeeListID: this.sortedByTask[0].Day0.EmployeeListID,
        //         TimeCardDate: moment(this.sortedByTask[0].Day0.WorkDate).format(
        //             'MM/DD/YYYY'
        //         ),
        //         MyDirection: null
        //     })
        // );
        this.requireSubmitFlag = true;
    }

    private handlePendingSaveBeforeSubmit(
        submitType: 'week' | 'period'
    ): boolean {
        if (
            !this.saveOnCellBlur &&
            (this.hasUnsavedChanges || this.pendingTimeCardUpdates.size > 0)
        ) {
            this.deferredSubmitType = submitType;
            this.requireSubmitFlag = true;
            this.saveAllPending();
            return true;
        }

        return false;
    }

    public timeCardSubmit(submitdata) {
        this.tcSubmit.emit(submitdata);
    }

    setupObservables() {
        this.log.verbose({
            type: 'TimeCardPresenterComponent:setupObservables'
        });
        this.userSub$ = this.userStore.pipe(
            takeWhile(_ => this.active),
            select(fromUser.getUser)
        );
    }
    setupSubscriptions() {
        this.log.verbose({
            type: 'TimeCardPresenterComponent:setupSubscriptions'
        });
        this.store
            .pipe(select(docReducers.selectAll), takeWhile(() => this.active))
            .subscribe(docs => {
                this.documentationRows = docs ?? [];
            });
        this.AddDocumentation.pipe(takeWhile(() => this.active)).subscribe(
            timecard => {
                this.log.verbose({
                    type: 'TimeCardPresenterComponent:AddDocumentation',
                    timecard
                });
                this.displayDocumentation = true;
            }
        );
        merge(this.dRSelectedSubject, this.userInfoSubject)
            .pipe(
                takeWhile(() => this.active),
                tap(x =>
                    this.log.verbose({
                        type: 'TimeCardPresenterComponent:userdirectreport/userinfo',
                        x
                    })
                )
            )
            .subscribe(x => {
                this.EmployeeIdSubject.next(x.EmployeeListID);
            });

        this.userSub$
            .pipe(
                takeWhile(() => this.active),
                tap(x =>
                    this.log.verbose({
                        type: 'TimeCardPresenterComponent:userSub$',
                        x
                    })
                ),
                filter(x => !!x)
            )
            .subscribe(user => {
                this.userInfoSubject.next(user.userInfo);
                this.user = user.userInfo;
                this.employeeListID = user.userInfo.EmployeeListID;
                this.roleGroupID = user.userInfo.RoleGroupID;
                this.employeeName = user.userInfo.EmployeeName;
                this.timecardDocHeader = 'Timecard Documentation';

                if (this.isDRSelected == false) {
                    this.detailsLabel = `HR Details for ${this.employeeName}`;
                }

                this.start =
                    user.userInfo.UserEntryStartDate &&
                    user.userInfo.UserEntryStartDate.toString();
                const end =
                    user.userInfo.UserEntryEndDate &&
                    user.userInfo.UserEntryEndDate.toString();
                const startDate = new Date(this.start);
                const endDate = new Date(end);
                this.userEntryStartDate = this.transformDate(startDate);
                this.userEntryEndDate = this.transformDate(endDate);
                this.signaturePolicyRequired =
                    user.userInfo.Signaturepolicyrequired;
                this.showSignaturePolicy = user.userInfo.ShowSignaturePolicy;
                this.selectedProcessRole = this.getProcessRole(
                    this.process.ProcessID,
                    this.user
                );
                if (user.userInfo.AccountNumber != null) {
                    this.accountNumber = user.userInfo.AccountNumber;
                } else {
                    this.accountNumber = '';
                }
                this.expectedHours = user.userInfo.UserEntryPeriodExpectedHours;
                this.requireTimeSubmit = user.userInfo.Requiretimesubmit;
                this.leaveInfo = user.userInfo.LeaveAccrualInfo;
                this.setProcessRole(this.selectedProcessRole);
            });

        this.authSub = this.authStore
            .pipe(takeWhile(_ => this.active))
            .subscribe(auth => {
                if (auth) {
                    this.userPassword = auth['auth'].password;
                }
            });

        this.WeeklySummarySubject.pipe(
            takeWhile(() => this.active),
            tap(cards =>
                this.log.verbose({
                    type: 'TimeCardPresenterComponent:WeeklySummarySubject',
                    cards
                })
            ),
            filter(x => !!x && x.length === 0),
            tap(cards =>
                this.log.verbose({
                    type: 'TimeCardPresenterComponent:WeeklySummarySubject:empty',
                    cards
                })
            )
        ).subscribe(() => {
            if (this.isSupervisor || this.isTaskManager || this.isSuperUser) {
                try {
                    this.createEmptyWeeklyTabulator(this, '#tabWeeklySummary');
                } catch {}
            }
        });

        this.TimeCardsSubject.pipe(
            takeWhile(() => this.active),
            tap(cards =>
                this.log.verbose({
                    type: 'TimeCardPresenterComponent:TimeCardsSubject',
                    cards
                })
            ),
            filter(x => !!x && x.length === 0),
            tap(cards =>
                this.log.verbose({
                    type: 'TimeCardPresenterComponent:TimeCardsSubject:empty',
                    cards
                })
            )
        ).subscribe(() => {
            this.displayOver24HoursWarning = false;
            if (this.isSuperUser || this.isSupervisor || this.isTaskManager) {
                try {
                    this.createEmptyTabulator(this, '#tabTimeCard');
                } catch {}
            }
        });
        this.TimeCardsSubject.pipe(
            takeWhile(() => this.active),
            filter(x => !!x && x.length > 0),
            tap(cards =>
                this.log.verbose({
                    type: 'TimeCardPresenterComponent:TimeCardsSubject:not empty',
                    cards
                })
            )
        ).subscribe(cards => {
            if (this.pivot == true) {
                let data: any;
                data = fromShared.fastpivot(cards);
                const max = data['WorkDateHdr']._labels.length;
                this.numOfDaysInWeek = max;
                const firstDay = data['WorkDateHdr']._labels[0];
                const lastDay = data['WorkDateHdr']._labels[max - 1];

                const days = [];
                const byTask = [];
                const count = max;
                let i = 0;
                const wdcount = 0;
                data.EmpAuthID._labels.forEach((task: string) => {
                    const taskNum = Number(task);
                    const item: any = {};
                    i++;
                    for (let index = 0; index < count; index++) {
                        const taskCards = cards.filter(
                            // this could be the issue with the split day on the 1st day of week
                            x => x.EmpAuthID === taskNum
                        );
                        const currentTask = taskCards.find(
                            x => x.EmpAuthID === taskNum
                        );
                        const taskAvailableHours =
                            this.getTaskAvailableHours(taskCards);
                        item.task = currentTask.TaskDisplay;
                        item.AvailableHours = taskAvailableHours;
                        this.PeriodHasSplitDay = cards[0].PeriodHasSplitDay;
                        item.TaskSortOrder = currentTask.TaskSortOrder;
                        const todayTaskCard = taskCards.find(
                            x =>
                                x.WorkDateHdr ===
                                data['WorkDateHdr']._labels[index] // index is 0 when first day is split, but the split header is 7
                        );

                        if (todayTaskCard) {
                            item.TotalDocumentedHours =
                                todayTaskCard.TotalDocumentedHours;
                            item.weeklyTotal =
                                this.getTaskWeeklyTotal(taskCards);
                            item.availableHours = taskAvailableHours;
                            item.periodTotal = todayTaskCard.PeriodTotal;
                            item.serviceItem = todayTaskCard.ServiceItem;
                            item.payrollItem = todayTaskCard.PayrollItem;
                            item.empAuthURL = todayTaskCard.EmpAuthURL;
                            item.empAuthID = todayTaskCard.EmpAuthID;
                            item[`Day${index}`] = { ...todayTaskCard };
                        }
                    }
                    byTask.push(item);
                });

                this.log.verbose({
                    type: `TimeCardPresenterComponent:TimeCardsSubject:result`,
                    byTask
                });
                this.sortedByTask = byTask.sort((a, b) =>
                    this.compareTaskRowsByOrderAndName(a, b)
                );

                if (this.showAvailableHoursOnTimecard) {
                    if (this.hasMaxHours == false) {
                        this.showAvailableHoursColumn = false;
                    } else {
                        this.showAvailableHoursColumn = true;
                    }
                } else {
                    this.showAvailableHoursColumn = false;
                }

                this.flippedTimeCardData = this.sortedByTask;
                if (this.isApprovalOrValidationView) {
                    this.dynamicTableHeight = '33vh'; // '31.8vh'; // '26.5vh';
                } else if (this.isSuperUser) {
                    this.dynamicTableHeight = `${this.timecardMaxHeightVh}vh`;
                } else {
                    const rowCount = this.flippedTimeCardData[0].Day0.NbrOfRows;
                    const estimatedVh = 18 + rowCount * 2.4;
                    const clampedVh = Math.max(
                        20,
                        Math.min(this.timecardMaxHeightVh, estimatedVh)
                    );
                    this.dynamicTableHeight = `${clampedVh}vh`;
                }
                this.timecardBaseHeightPx = undefined;
                this.weeklySummaryExpandedHeight = 0;
                this.weeklySummaryCollapsedHeight = 0;

                this.createTabulatorForTimeCard(this, [], this.sortedByTask);
                setTimeout(() => {
                    this.adjustTimecardHeightForWeeklySummary();
                }, 0);
                this.pivot = false;
            } else {
                // Data updated (e.g. after save): recompute sortedByTask from new cards and refresh table
                const data = fromShared.fastpivot(cards);
                const max = data['WorkDateHdr']._labels.length;
                const byTask: any[] = [];
                const previousOrder = new Map<string, number>();
                this.sortedByTask?.forEach((row, index) => {
                    const key = String(
                        row?.empAuthID ?? row?.Day0?.EmpAuthID ?? row?.task ?? ''
                    );
                    previousOrder.set(key, index);
                });
                data.EmpAuthID._labels.forEach((task: string) => {
                    const taskNum = Number(task);
                    const item: any = {};
                    for (let index = 0; index < max; index++) {
                        const taskCards = cards.filter(
                            x => x.EmpAuthID === taskNum
                        );
                        const currentTask = taskCards.find(
                            x => x.EmpAuthID === taskNum
                        );
                        const taskAvailableHours =
                            this.getTaskAvailableHours(taskCards);
                        item.task = currentTask.TaskDisplay;
                        item.AvailableHours = taskAvailableHours;
                        this.PeriodHasSplitDay = cards[0].PeriodHasSplitDay;
                        item.TaskSortOrder = currentTask.TaskSortOrder;
                        const todayTaskCard = taskCards.find(
                            x =>
                                x.WorkDateHdr ===
                                data['WorkDateHdr']._labels[index]
                        );
                        if (todayTaskCard) {
                            item.TotalDocumentedHours =
                                todayTaskCard.TotalDocumentedHours;
                            item.weeklyTotal =
                                this.getTaskWeeklyTotal(taskCards);
                            item.availableHours = taskAvailableHours;
                            item.periodTotal = todayTaskCard.PeriodTotal;
                            item.serviceItem = todayTaskCard.ServiceItem;
                            item.payrollItem = todayTaskCard.PayrollItem;
                            item.empAuthURL = todayTaskCard.EmpAuthURL;
                            item.empAuthID = todayTaskCard.EmpAuthID;
                            item[`Day${index}`] = { ...todayTaskCard };
                        }
                    }
                    byTask.push(item);
                });
                this.sortedByTask = byTask.sort((a, b) =>
                    this.compareTaskRowsByOrderAndName(a, b, previousOrder)
                );
                this.flippedTimeCardData = this.sortedByTask;
                if (this.tabTimeCard) {
                    this.createTabulatorForTimeCard(this, [], this.sortedByTask);
                    // Full rebuild already applied returned data; avoid stale partial row.update.
                    this.currentCell = null;
                }
            }

            this.refreshOver24HoursWarning();

            // if (this.showAvailableHoursOnTimecard) {
            //     if (this.hasMaxHours == false) {
            //         this.showAvailableHoursColumn = false;
            //     } else {
            //         this.showAvailableHoursColumn = true;
            //     }
            // } else {
            //     this.showAvailableHoursColumn = false;
            // }

            if (this.requireSubmitFlag === true) {
                if (this.deferredSubmitType === 'week') {
                    this.requireSubmitFlag = false;
                    this.deferredSubmitType = null;
                    this.requireTimeSubmitWeekClicked();
                } else if (this.deferredSubmitType === 'period') {
                    this.requireSubmitFlag = false;
                    this.deferredSubmitType = null;
                    this.requireTimeSubmitPeriodClicked();
                } else {
                    //this.createTabulatorForTimeCard(this, [], this.sortedByTask);
                    this.requireSubmitFlag = false;
                }
            }

            if (this.tabTimeCard) {
                if (this.weeklyHeaderSelected === true) {
                    // this.createTabulatorForTimeCard(
                    //     this,
                    //     [],
                    //     this.sortedByTask
                    // );
                    this.weeklyHeaderSelected = false;
                }
                if (
                    this.previousWeekClicked === true ||
                    this.nextWeekClicked === true
                ) {
                    // this.createTabulatorForTimeCard(
                    //     this,
                    //     [],
                    //     this.sortedByTask
                    // );
                } else {
                    this.tabAlreadyCreated = true;
                    if (this.drdropdown === true) {
                        // this.createTabulatorForTimeCard(
                        //     this,
                        //     [],
                        //     this.sortedByTask
                        // );
                        this.drdropdown = false;
                    } else {
                        if (this.isRefreshing === true) {
                            // this.createTabulatorForTimeCard(
                            //     this,
                            //     [],
                            //     this.sortedByTask
                            // );
                            this.isRefreshing = false;
                        } else {
                            if (this.currentCell) {
                                const row = this.currentCell.getRow();
                                const rowdata = row.getData();
                                const column = this.currentCell.getColumn();
                                const columnDef = column.getDefinition();
                                const columnField =
                                    columnDef.field.split('.')[0];
                                const day = columnField;
                                const updatedData = this.sortedByTask.find(
                                    x => x.empAuthID === rowdata.empAuthID
                                );

                                const updatedDay = this.timecardData.find(
                                    x => x.id == rowdata[day].id
                                );

                                if (
                                    updatedData &&
                                    this.hasProp(updatedData, [day]) &&
                                    updatedDay
                                ) {
                                    row.update({
                                        availableHours: updatedData.availableHours,
                                        weeklyTotal: updatedData.weeklyTotal,
                                        [day]: updatedDay
                                    });
                                }
                                //this.currentCell = null;
                                // this.sortedByTask = this.sortedByTask
                                //     .sort((a, b) => a.TaskSortOrder - b.TaskSortOrder)
                                //     .sort((a, b) => {
                                //         if (a.TaskSortOrder < b.TaskSortOrder) {
                                //             return -1;
                                //         }
                                //         if (a.TaskSortOrder > b.TaskSortOrder) {
                                //             return 1;
                                //         }
                                //         if (a.task > b.task) {
                                //             return 1;
                                //         }
                                //         if (a.task < b.task) {
                                //             return -1;
                                //         }
                                //     });
                                // for (var i = 0; i < this.sortedByTask.length; i++) {
                                //     this.log.verbose(`sortOrder ${i} - Task: ${this.sortedByTask[i].task}`);
                                // }

                                // this.log.verbose(
                                //     `row.update: hours ${updatedData[day].EmployeeHours}, timeid ${updatedData[day].EmpTimeID}, workdate ${updatedData[day].WorkDateHdr}`
                                // );
                            } else {
                                // this.createTabulatorForTimeCard(
                                //     this,
                                //     [],
                                //     this.sortedByTask
                                // );
                            }
                        }
                    }
                }
            } else {
                //this.createTabulatorForTimeCard(this, [], this.sortedByTask);
            }

            if (
                this.isSuperUser === false &&
                this.isSupervisor === false &&
                this.isTaskManager === false
            ) {
                let cellData;
                let currentTimeCard;
                if (this.currentCell) {
                    cellData = this.getTimecardDay(this.currentCell);
                    currentTimeCard = this._timecarddata.find(
                        x => x.EmpTimeID == cellData.EmpTimeID
                    );
                }
            }
        });

        this.WeeklySummarySubject.pipe(
            takeWhile(() => this.active),
            filter(x => !!x && x.length > 0),
            tap(cards =>
                this.log.verbose({
                    type: 'TimeCardPresenterComponent:WeeklySummarySubject:not empty',
                    cards
                })
            )
        ).subscribe(cards => {
            let data: any;
            data = fromShared.fastpivot(cards);
            const max = data['TimeWeek']._labels.length;
            this.log.verbose({
                type: 'TimeCardPresenterComponent:WeeklySummarySubject',
                data,
                max
            });
            const firstWeek = moment(data['TimeWeek']._labels[0]).startOf(
                'week'
            );
            const firstWeekString = data['TimeWeek']._labels[0];
            const lastWeek = moment(data['TimeWeek']._labels[max - 1]);

            this.log.verbose({
                type: 'TimeCardPresenterComponent:WeeklySummarySubject',
                firstWeek,
                lastWeek
            });
            const weeks = [];
            const byTask = [];
            const count = max;
            let i = 0;
            data.EmpAuthID._labels.forEach((task: string) => {
                const item: any = {};
                const taskNum = Number(task);
                i++;
                for (let index = 0; index < count; index++) {
                    const taskCards = cards.filter(
                        x => x.EmpAuthID === taskNum
                    );
                    const currentTask = taskCards.find(
                        x => x.EmpAuthID === taskNum
                    );
                    item.task = currentTask.TaskLongName;
                    item.TaskSortOrder = currentTask.TaskSortOrder;
                    const todayTaskCard = taskCards.find(
                        x => x.TimeWeek === data['TimeWeek']._labels[index]
                    );
                    if (todayTaskCard) {
                        item.serviceItem = todayTaskCard.ServiceItem;
                        item.payrollItem = todayTaskCard.PayrollItem;
                        item.empAuthPeriod = todayTaskCard.EmpAuthPeriod;
                        item.availableHours = todayTaskCard.AvailableHours;
                        item.showAvailHours = todayTaskCard.ShowAvailHours;
                        item.periodTotal = todayTaskCard.PeriodTotal;
                        item.empAuthID = todayTaskCard.EmpAuthID;
                        item[`Week${index}`] = { ...todayTaskCard };
                    }
                }
                byTask.push(item);
            });
            this.log.verbose({
                type: `TimeCardPresenterComponent:TimeCardsSubject:result`,
                byTask
            });
            let wsSortedByTask;
            let weekIndex;
            if (byTask && byTask.length > 0) {
                wsSortedByTask = byTask.sort((a, b) =>
                    this.compareTaskRowsByOrderAndName(a, b)
                );

                this.flippedSummaryData = wsSortedByTask;
            }

            this.createTabulatorForWeeklySummary(this, [], wsSortedByTask);
            cards.forEach(el => {
                if (el.Dochoursgtworked == true) {
                    if (this.process.ProcessID == 87) {
                        this.displayDocWarning = false;
                    } else {
                        this.displayDocWarning = true;
                    }

                    return;
                }
            });
        });
    }

    private applyCellEditColors(cell: any): void {
        const rowdata = cell.getRow().getData();
        const column = cell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;
        const dayData = rowdata[day];
        const effectiveDayData = !this.saveOnCellBlur && dayData
            ? {
                ...dayData,
                Backcolor_hex: null,
                backcolor_hex: null,
                Forecolor_hex: null,
                forecolor_hex: null
            }
            : dayData;

        const context = {
            isReadOnly: false, // Cell is being edited, so not readonly
            isOutOfDateRange: false,
            hasValue: true, // Cell has a value since it's being edited
            cellValue: cell.getValue(),
            dayData: effectiveDayData,
            userRole: this.isSuperUser ? 'superUser' as const :
                     this.isSupervisor ? 'supervisor' as const :
                     this.isTaskManager ? 'taskManager' as const : 'user' as const,
            requireTimeSubmit: this.requireTimeSubmit,
            userWebColors: this.userWebColors
        };

        const colors = CellColorManager.getCellColors(context);
        CellColorManager.applyCellColors(cell, colors);
    }

    countDecimals(value) {
        if (Math.floor(value) !== value) {
            return value.toString().split('.')[1].length || 0;
        } else {
            return 0;
        }
    }

    onIncludeDisapprovedTime($event) {
        this.cbxValue = $event.checked;
    }

    /** Stamp the on-screen week so post-action reload stays on the same week. */
    private emitManagementUpdate(data: IManagementAction) {
        if (this.sortedByTask?.[0]?.Day0?.WorkDate) {
            data.DisplayedWeekStart = moment(
                this.sortedByTask[0].Day0.WorkDate
            ).format('MM/DD/YYYY');
        }
        this.managementUpdate.emit(data);
    }

    public managementAction(action) {
        this.mgmtActionInProgress = true;
        this.pivot = true;
        if (this.selectedDirectReports && this.selectedDirectReports.length > 0) {
            this.directReportListID =
            this.selectedDirectReports[0].EmployeeListID;
        }
        if (this.showManagementActionDialog == true) {
            this.IsDisabled = true;
            let data: IManagementAction;
            const mgmtrowdata = this.getSelectedDirectReportData();
            if (!mgmtrowdata) {
                return;
            }
            const tcrowdata = this.currentRow.getData();
            if (action === 'approve') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12024, // this.roleGroupID,
                    usrDirectReports: [
                        {
                            EmployeeListID: mgmtrowdata.EmployeeListID,
                            EmployeeName: 'na',
                            IsActive: 1
                        }
                    ],
                    TimeCardStatus: 2.0,
                    StartDate: this.selectedCellDate,
                    EndDate: this.selectedCellDate,
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    IncludeDisapproved: this.cbxValue,
                    EmpTimeID: tcrowdata[this.currentDay].EmpTimeID,
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Approvals Complete';
                this.showManagementActionDialog = false;
                this.selectedDirectReports = [];
            } else if (action === 'disapprove') {
                this.dialogVisible = true;
            } else if (action === 'unapprove') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12024, // this.roleGroupID,
                    usrDirectReports: [
                        {
                            EmployeeListID: mgmtrowdata.EmployeeListID,
                            EmployeeName: 'na',
                            IsActive: 1
                        }
                    ],
                    TimeCardStatus: 1.0,
                    StartDate: this.selectedCellDate,
                    EndDate: this.selectedCellDate,
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    IncludeDisapproved: this.cbxValue,
                    EmpTimeID: tcrowdata[this.currentDay].EmpTimeID,
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Unapprovals Complete';
                this.showManagementActionDialog = false;
                this.selectedDirectReports = [];
            } else if (action === 'validate') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12025, // this.roleGroupID,
                    usrDirectReports: [
                        {
                            EmployeeListID: mgmtrowdata.EmployeeListID,
                            EmployeeName: 'na',
                            IsActive: 1
                        }
                    ],
                    TimeCardStatus: 1.5,
                    StartDate: this.selectedCellDate,
                    EndDate: this.selectedCellDate,
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    IncludeDisapproved: this.cbxValue,
                    EmpTimeID: tcrowdata[this.currentDay].EmpTimeID,
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Validations Complete';
                this.showManagementActionDialog = false;
                this.selectedDirectReports = [];
            } else if (action === 'disapprove_validate') {
                this.dialogVisible = true;
            } else if (action === 'unvalidate') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12025, // this.roleGroupID,
                    usrDirectReports: [
                        {
                            EmployeeListID: mgmtrowdata.EmployeeListID,
                            EmployeeName: 'na',
                            IsActive: 1
                        }
                    ],
                    TimeCardStatus: 1.0,
                    StartDate: this.selectedCellDate,
                    EndDate: this.selectedCellDate,
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    IncludeDisapproved: this.cbxValue,
                    EmpTimeID: tcrowdata[this.currentDay].EmpTimeID,
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Unvalidations Complete';
                this.showManagementActionDialog = false;
                this.selectedDirectReports = [];
            } else {
                data = null;
                this.selectedDirectReports = [];
            }
        }
        if (this.IsDisabled === false) {
            let data: IManagementAction;
            if (action === 'approve') {
                if (this.showManagementActionDialog == true) {
                    const rowdata = this.getSelectedDirectReportData();
                    if (!rowdata) {
                        return;
                    }
                    data = {
                        EmployeeListID: this.employeeListID,
                        UserGroupID: 12024, // this.roleGroupID,
                        usrDirectReports: [
                            {
                                EmployeeListID: rowdata.EmployeeListID,
                                EmployeeName: 'na',
                                IsActive: 1
                            }
                        ],
                        TimeCardStatus: 2.0,
                        StartDate: this.selectedCellDate,
                        EndDate: this.selectedCellDate,
                        MgmtDateRangeStart: this.mgmtDateRangeStart,
                        MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                        MgrComment: '',
                        IncludeDisapproved: this.cbxValue,
                        Processid: this.process.ProcessID,
                        MyDrsOnly: this.showMyDRs
                    };
                    this.emitManagementUpdate(data);
                    //this.managementActionCompleteMsg = 'Approvals Complete';
                    //this.showManagementActionDialog = false;
                    this.selectedDirectReports = [];
                } else {
                    data = {
                        EmployeeListID: this.employeeListID,
                        UserGroupID: 12024, // this.roleGroupID,
                        usrDirectReports: this.selectedDirectReports,
                        TimeCardStatus: 2.0,
                        StartDate: moment(
                            this.approveFormGroup.controls['dateRange'].value[0]
                        ).format('MM/DD/YYYY'),
                        EndDate: moment(
                            this.approveFormGroup.controls['dateRange'].value[1]
                        ).format('MM/DD/YYYY'),
                        MgmtDateRangeStart: this.mgmtDateRangeStart,
                        MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                        MgrComment: '',
                        IncludeDisapproved: this.cbxValue,
                        Processid: this.process.ProcessID,
                        MyDrsOnly: this.showMyDRs
                    };
                    this.emitManagementUpdate(data);
                    //this.managementActionCompleteMsg = 'Approvals Complete';
                    this.selectedDirectReports = [];
                }
            } else if (action === 'lock') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12024, // this.roleGroupID,
                    usrDirectReports: this.selectedDirectReports,
                    TimeCardStatus: 5.0,
                    StartDate: moment(
                        this.approveFormGroup.controls['dateRange'].value[0]
                    ).format('MM/DD/YYYY'),
                    EndDate: moment(
                        this.approveFormGroup.controls['dateRange'].value[1]
                    ).format('MM/DD/YYYY'),
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Lock Complete';
                this.selectedDirectReports = [];
            } else if (action === 'unlock') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12024, // this.roleGroupID,
                    usrDirectReports: this.selectedDirectReports,
                    TimeCardStatus: 6.0,
                    StartDate: moment(
                        this.approveFormGroup.controls['dateRange'].value[0]
                    ).format('MM/DD/YYYY'),
                    EndDate: moment(
                        this.approveFormGroup.controls['dateRange'].value[1]
                    ).format('MM/DD/YYYY'),
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Unlock Complete';
                this.selectedDirectReports = [];
            } else if (action === 'disapprove') {
                this.dialogVisible = true;
            } else if (action === 'unapprove') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12024, // this.roleGroupID,
                    usrDirectReports: this.selectedDirectReports,
                    TimeCardStatus: 1.0,
                    StartDate: moment(
                        this.unapproveFormGroup.controls['dateRange'].value[0]
                    ).format('MM/DD/YYYY'),
                    EndDate: moment(
                        this.unapproveFormGroup.controls['dateRange'].value[1]
                    ).format('MM/DD/YYYY'),
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Unapprovals Complete';
                this.selectedDirectReports = [];
            } else if (action === 'validate') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12025, // this.roleGroupID,
                    usrDirectReports: this.selectedDirectReports,
                    TimeCardStatus: 1.5,
                    StartDate: moment(
                        this.validateFormGroup.controls['dateRange'].value[0]
                    ).format('MM/DD/YYYY'),
                    EndDate: moment(
                        this.validateFormGroup.controls['dateRange'].value[1]
                    ).format('MM/DD/YYYY'),
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Validations Complete';
                this.selectedDirectReports = [];
                // this.ws_panelExpanded = true;
                // this.tc_panelExpanded = false;
            } else if (action === 'disapprove_validate') {
                this.dialogVisible = true;
            } else if (action === 'unvalidate') {
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: 12025, // this.roleGroupID,
                    usrDirectReports: this.selectedDirectReports,
                    TimeCardStatus: 1.0,
                    StartDate: moment(
                        this.unvalidateFormGroup.controls['dateRange'].value[0]
                    ).format('MM/DD/YYYY'),
                    EndDate: moment(
                        this.unvalidateFormGroup.controls['dateRange'].value[1]
                    ).format('MM/DD/YYYY'),
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: '',
                    Processid: this.process.ProcessID,
                    MyDrsOnly: this.showMyDRs
                };
                this.emitManagementUpdate(data);
                //this.managementActionCompleteMsg = 'Unvalidations Complete';
                this.selectedDirectReports = [];
            } else {
                data = null;
                this.selectedDirectReports = [];
            }
            // this.directReportListID =
            //     this.selectedDirectReports[0].EmployeeListID;
        }
        this.IsDisabled = true;
        //this.selectedDirectReports = [];
        // if (this.showManagementActionDialog != true) {
        //     this.showManagementActionCompleteMsg = true;
        //     setTimeout(() => {
        //         this.showManagementActionCompleteMsg = false;
        //     }, 5000);
        // }
        //this.showManagementActionDialog = false;
    }

    mgrMessageEntered() {
        let data: IManagementAction;
        this.dialogVisible = false;
        let roleid;
        if (this.isTaskManager === true) {
            roleid = 12025;
        }
        if (this.isSupervisor === true) {
            roleid = 12024;
        }
        if (this.showManagementActionDialog == true) {
            const mgmtrowdata = this.getSelectedDirectReportData();
            if (!mgmtrowdata) {
                return;
            }
            const tcrowdata = this.currentRow.getData();
            data = {
                EmployeeListID: this.employeeListID,
                UserGroupID: roleid, // this.roleGroupID,
                usrDirectReports: [
                    {
                        EmployeeListID: mgmtrowdata.EmployeeListID,
                        EmployeeName: 'na',
                        IsActive: 1
                    }
                ],
                TimeCardStatus: 3.0,
                StartDate: this.selectedCellDate,
                EndDate: this.selectedCellDate,
                MgmtDateRangeStart: this.mgmtDateRangeStart,
                MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                MgrComment: this.mgrComment,
                // IncludeDisapproved: this.cbxValue,
                EmpTimeID: tcrowdata[this.currentDay].EmpTimeID,
                MyDrsOnly: this.showMyDRs
            };
            this.showManagementActionDialog = false;
        } else {
            if (roleid == 12025) {
                //Task Manager
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: roleid, // this.roleGroupID,
                    usrDirectReports: this.selectedDirectReports,
                    TimeCardStatus: 3.0,
                    StartDate: moment(
                        this.disapproveValidateFormGroup.controls['dateRange'].value[0]
                    ).format('MM/DD/YYYY'), // get the first date of the range
                    EndDate: moment(
                        this.disapproveValidateFormGroup.controls['dateRange'].value[1]
                    ).format('MM/DD/YYYY'), // get the last date of the range
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: this.mgrComment,
                    MyDrsOnly: this.showMyDRs
                };
            } else {
                // Supervisor
                data = {
                    EmployeeListID: this.employeeListID,
                    UserGroupID: roleid, // this.roleGroupID,
                    usrDirectReports: this.selectedDirectReports,
                    TimeCardStatus: 3.0,
                    StartDate: moment(
                        this.disapproveFormGroup.controls['dateRange'].value[0]
                    ).format('MM/DD/YYYY'), // get the first date of the range
                    EndDate: moment(
                        this.disapproveFormGroup.controls['dateRange'].value[1]
                    ).format('MM/DD/YYYY'), // get the last date of the range
                    MgmtDateRangeStart: this.mgmtDateRangeStart,
                    MgmtDateRangeEnd: this.mgmtDateRangeEnd,
                    MgrComment: this.mgrComment,
                    MyDrsOnly: this.showMyDRs
                };
            }
        }
        this.emitManagementUpdate(data);
        //this.managementActionCompleteMsg = 'Disapprovals Complete';
        this.mgrComment = '';
        this.selectedDirectReports = [];
    }

    public clearFilters() {
        // reset filters in filter form group
        // if clearing direct reports filter, will need to reload the grid with the data of whoever is logged in
        this.filterFormGroup.controls['directReports'].reset();
        this.filterFormGroup.controls['tasks'].reset();

        if (this.isUser === true) {
            this.tabTimeCard.clearFilter(true);
        } else {
            if (this.isSuperUser) {
                this.tabWeeklySummary.clearData(true);
                this.timecardHeader = 'TimeCard';
                this.weeklySummaryHeader = 'Weekly View';
            }
            this.tabTimeCard.clearData();
            this.isDRSelected = false;
        }
    }

    hasProp(obj, prop): boolean {
        if (!obj) {
            return false;
        }
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }

    /**
     * Available hours is a task-level value; after save only the edited day is updated in the store.
     * Prefer the most recently modified day so the column reflects the API response.
     */
    private getTaskAvailableHours(taskCards: ITimeCard[]): string | number | null {
        if (!taskCards?.length) {
            return null;
        }
        const withHours = taskCards.filter(
            c => c?.AvailableHours != null && c.AvailableHours !== ''
        );
        if (!withHours.length) {
            return null;
        }
        const latest = withHours.reduce((a, b) => {
            const aTime = a?.DateLastModified
                ? new Date(a.DateLastModified).getTime()
                : 0;
            const bTime = b?.DateLastModified
                ? new Date(b.DateLastModified).getTime()
                : 0;
            return bTime >= aTime ? b : a;
        });
        return latest.AvailableHours;
    }

    private getTaskWeeklyTotal(taskCards: ITimeCard[]): number | null {
        if (!taskCards?.length) {
            return null;
        }
        const withTotal = taskCards.filter(c => c?.WeeklyTotal != null);
        if (!withTotal.length) {
            return null;
        }
        const latest = withTotal.reduce((a, b) => {
            const aTime = a?.DateLastModified
                ? new Date(a.DateLastModified).getTime()
                : 0;
            const bTime = b?.DateLastModified
                ? new Date(b.DateLastModified).getTime()
                : 0;
            return bTime >= aTime ? b : a;
        });
        return latest.WeeklyTotal;
    }

    /**
     * Coerce TaskSortOrder for row comparison. JSON null must not become 0 —
     * Number(null) === 0 would sort that row to the top after a save/refresh.
     */
    private taskSortOrderForCompare(raw: any): number {
        if (raw == null) {
            return NaN;
        }
        if (typeof raw === 'string' && raw.trim() === '') {
            return NaN;
        }
        const n = Number(raw);
        return Number.isFinite(n) ? n : NaN;
    }

    private compareTaskRowsByOrderAndName(
        a: any,
        b: any,
        previousOrder?: Map<string, number>
    ): number {
        const aOrder = this.taskSortOrderForCompare(a?.TaskSortOrder);
        const bOrder = this.taskSortOrderForCompare(b?.TaskSortOrder);
        const aHasOrder = Number.isFinite(aOrder);
        const bHasOrder = Number.isFinite(bOrder);

        if (aHasOrder && bHasOrder && aOrder !== bOrder) {
            return aOrder - bOrder;
        }

        if (previousOrder) {
            const aKey = String(a?.empAuthID ?? a?.Day0?.EmpAuthID ?? a?.task ?? '');
            const bKey = String(b?.empAuthID ?? b?.Day0?.EmpAuthID ?? b?.task ?? '');
            const aPrev = previousOrder.get(aKey);
            const bPrev = previousOrder.get(bKey);
            if (aPrev != null && bPrev != null && aPrev !== bPrev) {
                return aPrev - bPrev;
            }
        }

        if (aHasOrder !== bHasOrder) {
            return aHasOrder ? -1 : 1;
        }

        const aTask = (a?.task ?? '').toString();
        const bTask = (b?.task ?? '').toString();
        return aTask.localeCompare(bTask);
    }

    public goToNextOrPreviousWeek(direction: string, bypassUnsavedPrompt = false) {
        if (!bypassUnsavedPrompt && this.hasStagedTimecardEdits()) {
            this.confirmLeaveUnsavedTimeEntries(() =>
                this.goToNextOrPreviousWeek(direction, true)
            );
            return;
        }

        this.pivot = true;
        if (direction === 'prev') {
            this.previousWeekClicked = true;
            this.nextWeekClicked = false;
            // get the first date in the displayed week
            const firstDate = this.sortedByTask[0].Day0.WorkDate.toString();
            // emit event to features.ts and pass the date and direction
            if (this.isSupervisor || this.isTaskManager) {
                this.nextOrPrevious.emit({
                    empListID: this.directReportListID,
                    date: firstDate,
                    direction: direction,
                    processid: this.process.ProcessID,
                    endDate: this.mgmtDateRangeEnd
                });
            }
            if (this.isSuperUser) {
                if (this.isDRSelected === true) {
                    this.nextOrPrevious.emit({
                        empListID: this.directReportListID,
                        date: firstDate,
                        direction: direction
                    });
                    if (new Date(firstDate).getTime() < new Date(this.user.UserEntryStartDate.toString()).getTime()) {
                        this.emptyWeeklyTabPlaceholder = "Timecard is outside of entry dates."
                        this.createEmptyWeeklyTabulator(this, '#tabWeeklySummary');
                    } else {
                        this.emptyWeeklyTabPlaceholder = "No Data Available."
                    }
                }
            }
            if (this.isUser) {
                this.nextOrPrevious.emit({
                    empListID: this.sortedByTask[0].Day0.EmployeeListID,
                    date: firstDate,
                    direction: direction
                });
            }
        } else {
            this.previousWeekClicked = false;
            this.nextWeekClicked = true;
            if (this.hasProp(this.sortedByTask[0], 'Day7') === false) {
                this.sortedByTask[0] = {
                    Day0: this.sortedByTask[0].Day0,
                    Day1: this.sortedByTask[0].Day1,
                    Day2: this.sortedByTask[0].Day2,
                    Day3: this.sortedByTask[0].Day3,
                    Day4: this.sortedByTask[0].Day4,
                    Day5: this.sortedByTask[0].Day5,
                    Day6: this.sortedByTask[0].Day6,
                    Day7: {
                        ChangeComment: null,
                        CreateDate: null,
                        DateLastModified: null,
                        CurrentUserListID: null,
                        DailyTotal: null,
                        DateColor: null,
                        DatePurpose: null,
                        Deletedoc: null,
                        EmpAuthEndDate: null,
                        EmpAuthID: null,
                        EmpAuthStartDate: null,
                        EmpAuthURL: null,
                        EmpTimeID: null,
                        EmployeeHours: null,
                        EmployeeListID: null,
                        IsReadOnly: null,
                        IsTimeClockTime: null,
                        LeaveAccrualInfo: null,
                        LeavePayout: null,
                        LeavePayoutWeek: null,
                        NbrOfRows: null,
                        OutOfDateRange: null,
                        PayrollItem: null,
                        PeriodHasSplitDay: null,
                        ReadOnlyReason: null,
                        Row_Version: null,
                        ServiceItem: null,
                        SplitWorkDate: null,
                        Status: null,
                        TaskDisplay: null,
                        TaskLongName: null,
                        TimeStatus: null,
                        WeeklyTotal: null,
                        WorkDate: null,
                        WorkDateHdr: null,
                        WorkDocumentedCount: null
                    },
                    Row_Version: this.sortedByTask[0].Row_Version,
                    empAuthID: this.sortedByTask[0].empAuthID,
                    empAuthURL: this.sortedByTask[0].empAuthURL,
                    payrollItem: this.sortedByTask[0].payrollItem,
                    periodTotal: this.sortedByTask[0].periodTotal,
                    serviceItem: this.sortedByTask[0].serviceItem,
                    task: this.sortedByTask[0].task,
                    weeklyTotal: this.sortedByTask[0].weeklyTotal
                };
            }
            // get the last date in the displayed week
            let lastDate;
            if (
                this.hasProp(this.sortedByTask[0].Day7, 'WorkDate') === true &&
                this.sortedByTask[0].Day7.WorkDate
            ) {
                lastDate = moment(this.sortedByTask[0].Day7.WorkDate).format(
                    'MM/DD/YYYY'
                );
            } else if (
                this.hasProp(this.sortedByTask[0].Day6, 'WorkDate') === true &&
                this.sortedByTask[0].Day6.WorkDate
            ) {
                lastDate = moment(this.sortedByTask[0].Day6.WorkDate).format(
                    'MM/DD/YYYY'
                );
            } else if (
                this.hasProp(this.sortedByTask[0].Day5, 'WorkDate') === true &&
                this.sortedByTask[0].Day5.WorkDate
            ) {
                lastDate = moment(this.sortedByTask[0].Day5.WorkDate).format(
                    'MM/DD/YYYY'
                );
            } else if (
                this.hasProp(this.sortedByTask[0].Day4, 'WorkDate') === true &&
                this.sortedByTask[0].Day4.WorkDate
            ) {
                lastDate = moment(this.sortedByTask[0].Day4.WorkDate).format(
                    'MM/DD/YYYY'
                );
            } else if (
                this.hasProp(this.sortedByTask[0].Day3, 'WorkDate') === true &&
                this.sortedByTask[0].Day3.WorkDate
            ) {
                lastDate = moment(this.sortedByTask[0].Day3.WorkDate).format(
                    'MM/DD/YYYY'
                );
            } else if (
                this.hasProp(this.sortedByTask[0].Day2, 'WorkDate') === true &&
                this.sortedByTask[0].Day2.WorkDate
            ) {
                lastDate = moment(this.sortedByTask[0].Day2.WorkDate).format(
                    'MM/DD/YYYY'
                );
            } else if (
                this.hasProp(this.sortedByTask[0].Day1, 'WorkDate') === true &&
                this.sortedByTask[0].Day1.WorkDate
            ) {
                lastDate = moment(this.sortedByTask[0].Day1.WorkDate).format(
                    'MM/DD/YYYY'
                );
            } else {
                lastDate = moment(this.sortedByTask[0].Day0.WorkDate).format(
                    'MM/DD/YYYY'
                );
            }

            const firstDate = this.sortedByTask[0].Day0.WorkDate.toString();
            if (this.isSupervisor || this.isTaskManager) {
                this.nextOrPrevious.emit({
                    empListID: this.directReportListID,
                    date: lastDate,
                    direction: direction,
                    processid: this.process.ProcessID,
                    endDate: this.mgmtDateRangeEnd
                });
            }
            if (this.isSuperUser) {
                if (this.isDRSelected === true) {
                    this.nextOrPrevious.emit({
                        empListID: this.directReportListID,
                        date: lastDate,
                        direction: direction
                    });
                }
            }
            if (this.isUser) {
                this.nextOrPrevious.emit({
                    empListID: this.sortedByTask[0].Day0.EmployeeListID,
                    date: lastDate,
                    direction: direction
                });
            }
        }
    }

    confirmBtnClickedForDocumentationExceedingHours() {
        const row = this.currentCell.getRow();
        const rowdata = this.currentCell.getRow().getData();
        const column = this.currentCell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;
        const value = this.currentCell.getValue();
        const today = moment(new Date()).format('MM/DD/YYYY');

        rowdata[day].Deletedoc = true;

        if (rowdata[day].CreateDate != null) {
            if (
                moment(rowdata[day].CreateDate).format('MM/DD/YYYY') === today
            ) {
                this.updateTime(this.currentCell);
            } else {
                this.changeCommentTask = rowdata.task;
                this.changeCommentDate = rowdata[day].WorkDateHdr;
                if (value != null) {
                    if (this.saveOnCellBlur) {
                        this.showDisplayNotePopup();
                    } else {
                        this.signaturePolicyCheck(this.currentCell);
                    }
                }
            }
        } else {
            this.updateTime(this.currentCell);
        }

        this.displayDocumentationExceedingHoursWarningPopup = false;
    }
    cancelBtnClickedForDocumentationExceedingHours() {
        const row = this.currentCell.getRow();
        const rowdata = this.currentCell.getRow().getData();
        const column = this.currentCell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;
        this.revertRowToPreviousValue(this.currentCell);
        this.displayDocumentationExceedingHoursWarningPopup = false;
    }

    confirmBtnClickedNegativeHours() {
        const row = this.currentCell.getRow();
        const rowdata = this.currentCell.getRow().getData();
        const column = this.currentCell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;
        if (rowdata[day].CreateDate != null) {
            this.revertRowToPreviousValue(this.currentCell);
        } else {
            row.update({
                [day]: {
                    InterfaceType: rowdata[day].InterfaceType,
                    TimerCreate: rowdata[day].TimerCreate,
                    ChangeComment: rowdata[day].ChangeComment,
                    CreateDate: rowdata[day].CreateDate,
                    DateLastModified: rowdata[day].DateLastModified,
                    CurrentUserListID: rowdata[day].CurrentUserListID,
                    DailyTotal: rowdata[day].DailyTotal,
                    DateColor: rowdata[day].DateColor,
                    DatePurpose: rowdata[day].DatePurpose,
                    Deletedoc: false,
                    EmpAuthEndDate: rowdata[day].EmpAuthEndDate,
                    EmpAuthID: rowdata[day].EmpAuthID,
                    EmpAuthStartDate: rowdata[day].EmpAuthStartDate,
                    EmpAuthURL: rowdata[day].EmpAuthURL,
                    EmpTimeID: rowdata[day].EmpTimeID,
                    EmployeeHours: '',
                    EmployeeListID: rowdata[day].EmployeeListID,
                    IsReadOnly: rowdata[day].IsReadOnly,
                    IsTimeClockTime: rowdata[day].IsTimeClockTime,
                    LeaveAccrualInfo: rowdata[day].LeaveAccrualInfo,
                    LeavePayout: rowdata[day].LeavePayout,
                    LeavePayoutWeek: rowdata[day].LeavePayoutWeek,
                    NbrOfRows: rowdata[day].NbrOfRows,
                    OutOfDateRange: rowdata[day].OutOfDateRange,
                    PayrollItem: rowdata[day].PayrollItem,
                    PeriodHasSplitDay: rowdata[day].PeriodHasSplitDay,
                    ReadOnlyReason: rowdata[day].ReadOnlyReason,
                    Row_Version: rowdata[day].Row_Version,
                    ServiceItem: rowdata[day].ServiceItem,
                    SplitWorkDate: rowdata[day].SplitWorkDate,
                    Status: rowdata[day].Status,
                    TaskDisplay: rowdata[day].TaskDisplay,
                    TaskLongName: rowdata[day].TaskLongName,
                    TimeStatus: rowdata[day].TimeStatus,
                    WeeklyTotal: rowdata[day].WeeklyTotal,
                    WorkDate: rowdata[day].WorkDate,
                    WorkDateHdr: rowdata[day].WorkDateHdr,
                    WorkDocumentedCount: rowdata[day].WorkDocumentedCount
                }
            });
        }

        this.showNegativeHoursDialog = false;
    }

    revertRowToPreviousValue(cell) {
        const row = cell.getRow();
        const rowdata = cell.getRow().getData();
        const column = cell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;

        // Get the old value using Tabulator's proper API
        const oldValue = cell.getOldValue();

        this.log.verbose({
            type: 'TimeCardPresenterComponent:revertRowToPreviousValue',
            day,
            oldValue,
            currentValue: cell.getValue()
        });

        row.update({
            [day]: {
                InterfaceType: rowdata[day].InterfaceType,
                TimerCreate: rowdata[day].TimerCreate,
                ChangeComment: rowdata[day].ChangeComment,
                CreateDate: rowdata[day].CreateDate,
                DateLastModified: rowdata[day].DateLastModified,
                CurrentUserListID: rowdata[day].CurrentUserListID,
                DailyTotal: rowdata[day].DailyTotal,
                DateColor: rowdata[day].DateColor,
                DatePurpose: rowdata[day].DatePurpose,
                Deletedoc: rowdata[day].Deletedoc,
                EmpAuthEndDate: rowdata[day].EmpAuthEndDate,
                EmpAuthID: rowdata[day].EmpAuthID,
                EmpAuthStartDate: rowdata[day].EmpAuthStartDate,
                EmpAuthURL: rowdata[day].EmpAuthURL,
                EmpTimeID: rowdata[day].EmpTimeID,
                EmployeeHours: oldValue, // Use the proper old value
                EmployeeListID: rowdata[day].EmployeeListID,
                IsReadOnly: rowdata[day].IsReadOnly,
                IsTimeClockTime: rowdata[day].IsTimeClockTime,
                LeaveAccrualInfo: rowdata[day].LeaveAccrualInfo,
                LeavePayout: rowdata[day].LeavePayout,
                LeavePayoutWeek: rowdata[day].LeavePayoutWeek,
                NbrOfRows: rowdata[day].NbrOfRows,
                OutOfDateRange: rowdata[day].OutOfDateRange,
                PayrollItem: rowdata[day].PayrollItem,
                PeriodHasSplitDay: rowdata[day].PeriodHasSplitDay,
                ReadOnlyReason: rowdata[day].ReadOnlyReason,
                Row_Version: rowdata[day].Row_Version,
                ServiceItem: rowdata[day].ServiceItem,
                SplitWorkDate: rowdata[day].SplitWorkDate,
                Status: rowdata[day].Status,
                TaskDisplay: rowdata[day].TaskDisplay,
                TaskLongName: rowdata[day].TaskLongName,
                TimeStatus: rowdata[day].TimeStatus,
                WeeklyTotal: rowdata[day].WeeklyTotal,
                WorkDate: rowdata[day].WorkDate,
                WorkDateHdr: rowdata[day].WorkDateHdr,
                WorkDocumentedCount: rowdata[day].WorkDocumentedCount,
                Backcolor_hex: rowdata[day].Backcolor_hex,
                Forecolor_hex: rowdata[day].Forecolor_hex
            }
        });
        this.refreshOver24HoursWarning();
    }

    signaturePolicyCheck(cell) {
        this.refreshOver24HoursWarning();
        if (!this.saveOnCellBlur) {
            this.markCellPendingAndUpdateRow(cell);
            return;
        }
        // CHECK IF SIGNATURE POLICY IS REQUIRED
        if (!this.isSuperUser) {
            // User is not a superuser
            if (this.signaturePolicyRequired === true && this.requireTimeSubmit == true) {
                this.timeCardUpdate.emit([this.getTimecardDay(cell)]);
                this.setCreateDateAfterSave(cell);
            } else {
                if (this.signaturePolicyRequired) {
                    // Signature policy is required
                    if (this.showSignaturePolicy === true) {
                        // Show the signature policy dialog
                        this.showPolicyPopup();
                    } else {
                        // Do not show the signature policy dialog
                        this.timeCardUpdate.emit([this.getTimecardDay(cell)]);
                        this.setCreateDateAfterSave(cell);
                    }
                } else {
                    // Signature policy is not required
                    this.timeCardUpdate.emit([this.getTimecardDay(cell)]);
                    this.setCreateDateAfterSave(cell);
                }
            }
        } else {
            // User is a superuser - do not need to show the signature policy dialog
            this.timeCardUpdate.emit([this.getTimecardDay(cell)]);
            this.setCreateDateAfterSave(cell);
        }
    }

    // Helper method to update CreateDate after saving
    setCreateDateAfterSave(cell) {
        const row = cell.getRow();
        const rowdata = row.getData();
        const column = cell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;

        // Set CreateDate to today's date to simulate what would happen after a successful save
        const today = new Date();
        console.log('Setting CreateDate after save for day:', day, 'to:', today);

        // Update the underlying data directly without using row.update() to preserve event handlers
        setTimeout(() => {
            try {
                // Get fresh data after the current update cycle completes
                const currentRowData = row.getData();

                // Directly update the CreateDate property without rebuilding the row
                // This preserves all event handlers attached to the cells
                currentRowData[day].CreateDate = today;
                
                console.log('CreateDate successfully set after timeout without row rebuild');
            } catch (error) {
                console.error('Error setting CreateDate:', error);
            }
        }, 100); // Small delay to let the current update cycle complete
    }

    showDocWarning() {
        this.msgs = [];
        this.msgs.push({
            severity: 'warn',
            summary: 'Warn Message',
            detail: 'You have documented hours that are greater than time entered.'
        });
    }

    private getGridDayHoursTotalsForColumn(day: string): {
        allHours: number;
        nonPayoutHours: number;
    } | null {
        if (!this.tabTimeCard) {
            return null;
        }
        const rows = this.tabTimeCard.getData() as any[];
        if (!rows || rows.length === 0) {
            return null;
        }
        let allHours = 0;
        let nonPayoutHours = 0;
        for (const r of rows) {
            const d = r[day];
            if (!d || typeof d !== 'object' || !('EmployeeHours' in d)) {
                continue;
            }
            const h = +(d.EmployeeHours ?? 0);
            if (!Number.isFinite(h)) {
                continue;
            }
            allHours += h;
            if (d.LeavePayout !== true) {
                nonPayoutHours += h;
            }
        }
        return { allHours, nonPayoutHours };
    }

    private refreshOver24HoursWarning(): void {
        const gridRows = this.tabTimeCard
            ? (this.tabTimeCard.getData() as any[])
            : null;
        const rows =
            gridRows && gridRows.length > 0 ? gridRows : this.sortedByTask;
        if (!rows || rows.length === 0) {
            this.displayOver24HoursWarning = false;
            return;
        }

        const dayCount = Math.max(this.numOfDaysInWeek || 0, 8);
        for (let i = 0; i < dayCount; i++) {
            const day = `Day${i}`;
            let total = 0;
            let hasLeavePayoutHours = false;
            for (const row of rows) {
                const d = row?.[day];
                if (!d || typeof d !== 'object' || !('EmployeeHours' in d)) {
                    continue;
                }
                const hours = +(d.EmployeeHours ?? 0);
                if (!Number.isFinite(hours)) {
                    continue;
                }
                total += hours;
                if (d.LeavePayout === true && hours !== 0) {
                    hasLeavePayoutHours = true;
                }
            }
            if (total > 24 && hasLeavePayoutHours) {
                this.displayOver24HoursWarning = true;
                return;
            }
        }
        this.displayOver24HoursWarning = false;
    }

    updateTime(cell) {
        this.previousWeekClicked = false;
        this.nextWeekClicked = false;
        const row = cell.getRow();
        const rowdata = cell.getRow().getData();
        const column = cell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;
        const cellValue: number = cell.getValue();
        const oldCellValue: number = cell.getOldValue();
        const today = moment(new Date()).format('MM/DD/YYYY');
        const createDate = moment(rowdata[day].CreateDate).format('MM/DD/YYYY');
        let maxHours;

        if (this.timecardData) {
            maxHours = rowdata[day].AvailableHours;
            const leavePayoutWeek = rowdata[day].LeavePayoutWeek;

            let dayHoursTotal: number;
            let nonPayoutDayHoursTotal: number;
            const gridDayTotals = this.getGridDayHoursTotalsForColumn(day);
            if (gridDayTotals) {
                dayHoursTotal = gridDayTotals.allHours;
                nonPayoutDayHoursTotal = gridDayTotals.nonPayoutHours;
            } else {
                const dataFilteredByDay = this.timecardData.filter(
                    x => x.SplitWorkDate === rowdata[day].SplitWorkDate
                );

                const dataFilteredByModDate = dataFilteredByDay.sort(
                    (a, b) =>
                        new Date(b.DateLastModified).getTime() -
                        new Date(a.DateLastModified).getTime()
                );

                let dailyTotalFromData = 0;
                let dailyTotalNonPayoutHours = 0;

                dataFilteredByModDate.forEach(c => {
                    if (c.EmployeeHours == null) {
                        c.EmployeeHours = 0;
                    }
                    dailyTotalFromData += +c.EmployeeHours;
                });
                dataFilteredByModDate.forEach(c => {
                    if (c.LeavePayout === true) {
                        return;
                    }
                    if (c.EmployeeHours == null) {
                        c.EmployeeHours = 0;
                    }
                    dailyTotalNonPayoutHours += +c.EmployeeHours;
                });

                if (rowdata[day].CreateDate != null) {
                    dayHoursTotal =
                        dailyTotalFromData - oldCellValue + +cellValue;
                    nonPayoutDayHoursTotal =
                        dailyTotalNonPayoutHours - oldCellValue + +cellValue;
                } else {
                    dayHoursTotal = dailyTotalFromData + +cellValue;
                    nonPayoutDayHoursTotal =
                        dailyTotalNonPayoutHours + +cellValue;
                }
            }

            // CHECK FOR DOCUMENTED TIME EXCEEDING TIME ENTERED
            if (+rowdata[day].WorkDocumentedCount > 0) {
                if (+rowdata[day].WorkDocumentedCount > +cellValue) {
                    this.displayDocWarning = true;
                } else {
                    this.displayDocWarning = false;
                }
            }

            // CHECK IF ENTRY IS A NEGATIVE NUMBER
            if (+cellValue < 0) {
                // Entry is a negative number
                // Show the negative hours dialog
                this.showNegativeHoursDialog = true;
            }

            // CHECK IF CELL HAS A VALUE
            if (cellValue || cellValue === 0) {
                // Cell is not empty
                this.currentDay = day;
                this.currentCell = cell;
                this.currentRow = row;

                // CHECK IF CURRENT WEEK HAS A LEAVE PAYOUT TASK
                if (leavePayoutWeek == true) {
                    // There is a task with leave payout in the current week - allow a daily total of over 24 hours
                    if (rowdata[day].LeavePayout == true) {
                        // Current task for entry is a leave payout task
                        // Allow over 24 hours to be entered
                    } else {
                        // Current task for entry is not a leave payout task
                        if (+cellValue > 24) {
                            // Entry is over 24
                            // Show exceed daily hours dialog
                            this.confirmservice
                                .confirmPromise({
                                    dialogText:
                                        'This entry brings your total hours for the day above 24. Entries bringing a daily total above 24 hours cannot be saved.',
                                    okText: 'OK',
                                    showCancel: false,
                                })
                                .then(() => {
                                    this.revertRowToPreviousValue(cell);
                                })
                                .catch(() => {
                                    this.revertRowToPreviousValue(cell);
                                });
                            return;
                        } else {
                            // Entry is less than 24
                            if (+nonPayoutDayHoursTotal > 24) {
                                // Time for the day (not including leave payout time) exceeds 24 hours
                                // Show exceed daily hours dialog
                                this.confirmservice
                                    .confirmPromise({
                                        dialogText:
                                            'This entry brings your total hours for the day above 24. Entries bringing a daily total above 24 hours cannot be saved.',
                                        okText: 'OK',
                                        showCancel: false,
                                    })
                                    .then(() => {
                                        this.revertRowToPreviousValue(cell);
                                    })
                                    .catch(() => {
                                        this.revertRowToPreviousValue(cell);
                                    });
                                return;
                            } else {
                                // Time for the day (not including leave payout time) does not exceed 24 hours
                            }
                        }
                    }
                } else {
                    // There is not a task with leave payout in the current week - do not allow a daily total of over 24 hours
                    if (+cellValue > 24) {
                        // Entry is over 24
                        // Show exceed daily hours dialog
                        this.confirmservice
                            .confirmPromise({
                                dialogText:
                                    'This entry brings your total hours for the day above 24. Entries bringing a daily total above 24 hours cannot be saved.',
                                okText: 'OK',
                                showCancel: false,
                            })
                            .then(() => {
                                this.revertRowToPreviousValue(cell);
                            })
                            .catch(() => {
                                this.revertRowToPreviousValue(cell);
                            });
                        return;
                    } else {
                        // Entry is less than 24
                        if (+dayHoursTotal > 24) {
                            // Daily total is over 24 hours
                            // Show exceed daily hours dialog
                            this.confirmservice
                                .confirmPromise({
                                    dialogText:
                                        'This entry brings your total hours for the day above 24. Entries bringing a daily total above 24 hours cannot be saved.',
                                    okText: 'OK',
                                    showCancel: false,
                                })
                                .then(() => {
                                    this.revertRowToPreviousValue(cell);
                                })
                                .catch(() => {
                                    this.revertRowToPreviousValue(cell);
                                });
                            return;
                        } else {
                            // Daily total is not over 24 hours
                        }
                    }
                }

                // CHECK IF TASK HAS MAX HOURS SET
                if (maxHours != null) {
                    // Task has max hours set
                    if (+maxHours - +cellValue < 0) {
                        // Entry exceeds the max hours
                        // Show max hours dialog
                        this.confirmservice
                            .confirmPromise({
                                dialogText:
                                    'This time entry will exceed hours budgeted for this authorization.  Are you sure you want to enter this time?',
                                okText: 'Yes',
                                cancelText: 'No'
                            })
                            .then(() => {
                                // CHECK IF THE CELL HAS A PREVIOUS ENTRY OR NOT
                                if (rowdata[day].CreateDate != null) {
                                    // Cell has time already (Entry edit)
                                    if (createDate == today) {
                                        // Entry was entered today
                                        this.signaturePolicyCheck(cell);
                                    } else {
                                        if (this.saveOnCellBlur) {
                                            // Entry was entered before today
                                            // Show comment change dialog
                                            this.changeCommentTask = rowdata.task;
                                            this.changeCommentDate =
                                                rowdata[day].WorkDateHdr;
                                            this.showDisplayNotePopup();
                                        } else {
                                            this.signaturePolicyCheck(cell);
                                        }
                                    }
                                } else {
                                    // Cell does not have time (New entry)
                                    this.signaturePolicyCheck(cell);
                                }
                                return;
                            })
                            .catch(() => {
                                this.revertRowToPreviousValue(cell);
                                return;
                            });
                        return;
                    } else {
                        // Entry does not exceed the max hours
                    }
                } else {
                    // Task does not have max hours set
                }

                // CHECK IF THE CELL HAS A PREVIOUS ENTRY OR NOT
                if (rowdata[day].CreateDate != null) {
                    // Cell has time already (Entry edit)
                    if (createDate == today) {
                        // Entry was entered today
                        this.signaturePolicyCheck(cell);
                    } else {
                        if (this.saveOnCellBlur) {
                            // Entry was entered before today
                            // Show comment change dialog
                            this.changeCommentTask = rowdata.task;
                            this.changeCommentDate = rowdata[day].WorkDateHdr;
                            this.showDisplayNotePopup();
                        } else {
                            this.signaturePolicyCheck(cell);
                        }
                    }
                } else {
                    // Cell does not have time (New entry)
                    this.signaturePolicyCheck(cell);
                }
            } else {
                // Cell is empty

                // Staged save: enter-then-clear is a no-op — drop pending edit, do not call API.
                if (!this.saveOnCellBlur && rowdata[day]) {
                    const id =
                        (rowdata.empAuthID ?? rowdata[day].EmpAuthID) +
                        rowdata[day].WorkDateHdr;
                    if (
                        this.pendingTimeCardUpdates.has(id) &&
                        this.pendingOriginalHours.get(id) == null
                    ) {
                        this.pendingTimeCardUpdates.delete(id);
                        this.pendingOriginalHours.delete(id);
                        this.setHasUnsavedChanges(
                            this.pendingTimeCardUpdates.size > 0
                        );
                        this.refreshOver24HoursWarning();
                        return;
                    }
                }

                // CHECK IF CELL HAD TIME AND WAS BACKSPACED
                console.log('Cell cleared debug - cellValue:', cellValue, 'CreateDate:', rowdata[day].CreateDate, 'day:', day);
                console.log('Cell getOldValue():', cell.getOldValue());
                console.log('Current EmployeeHours:', rowdata[day].EmployeeHours);

                // Show popup if cell was cleared AND either:
                // 1. It had saved data (CreateDate exists), OR
                // 2. It had a previous value in the current session (getOldValue exists), OR
                // 3. Current EmployeeHours is not 0/null (indicating it had a value before clearing)
                const hadSavedData = rowdata[day].CreateDate != null;
                const hadSessionValue = cell.getOldValue() != null && cell.getOldValue() !== '';
                const hadCurrentValue = rowdata[day].EmployeeHours != null && rowdata[day].EmployeeHours !== 0;

                if (cellValue === null && (hadSavedData || hadSessionValue || hadCurrentValue)) {
                    // Edited hours left blank
                    // Show delete hours dialog
                    console.log('Showing delete popup - hadSavedData:', hadSavedData, 'hadSessionValue:', hadSessionValue, 'hadCurrentValue:', hadCurrentValue);
                    this.currentDay = day; // Set the current day
                    this.currentCell = cell; // Set the current cell before showing popup
                    this.currentRow = row; // Set the current row
                    this.showDeleteHoursPopup();
                    //this.currentCell = null;
                } else {
                    console.log('NOT showing delete popup - cellValue:', cellValue, 'hadSavedData:', hadSavedData, 'hadSessionValue:', hadSessionValue, 'hadCurrentValue:', hadCurrentValue);
                }
            }
        }
    }

    showDocExceedingTimeDialog(cell) {
        this.currentCell = cell;
        this.displayDocumentationExceedingHoursWarningPopup = true;
    }

    getTimecardDay(cell) {
        const data = cell.getData();
        const column = cell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const cellData = data[columnField];
        return cellData;
    }

    /**
     * Stage a cell's current value as a pending save (no API call). Updates the row's weekly total for display.
     */
    markCellPendingAndUpdateRow(cell: Tabulator.CellComponent): void {
        const row = cell.getRow();
        const rowdata = row.getData();
        const column = cell.getColumn();
        const columnDef = column.getDefinition();
        const columnField = columnDef.field.split('.')[0];
        const day = columnField;
        const dayObj = rowdata[day];
        if (!dayObj) return;
        const id = (rowdata.empAuthID ?? dayObj.EmpAuthID) + dayObj.WorkDateHdr;
        const currentValue = cell.getValue();

        if (!this.pendingOriginalHours.has(id)) {
            const oldValue = cell.getOldValue();
            this.pendingOriginalHours.set(
                id,
                oldValue === '' || oldValue == null ? null : +oldValue
            );
        }

        // Reverted to original — nothing to save for this cell.
        const original = this.pendingOriginalHours.get(id);
        const currentBlank = currentValue == null || currentValue === '';
        const originalBlank = original == null;
        if (
            (currentBlank && originalBlank) ||
            (!currentBlank && !originalBlank && +currentValue === +original)
        ) {
            this.pendingTimeCardUpdates.delete(id);
            this.pendingOriginalHours.delete(id);
            this.setHasUnsavedChanges(this.pendingTimeCardUpdates.size > 0);
            return;
        }

        const updatedDay = {
            ...dayObj,
            EmployeeHours: currentValue,
            // Remove status coloring while edit is staged; backend response will restore correct status colors after save/sign.
            Backcolor_hex: null,
            backcolor_hex: null,
            Forecolor_hex: null,
            forecolor_hex: null
        };
        // Clone so later grid edits cannot mutate the staged payload.
        this.pendingTimeCardUpdates.set(id, { ...updatedDay });
        let weeklyTotal = 0;
        for (const k of Object.keys(rowdata)) {
            const v = rowdata[k];
            if (v && typeof v === 'object' && 'EmployeeHours' in v) {
                weeklyTotal += +(v.EmployeeHours ?? 0);
            }
        }
        row.update({ [day]: { ...updatedDay }, weeklyTotal });
        this.setHasUnsavedChanges(true);
    }

    private formatHoursForChangeSummary(value: any): string {
        if (value == null || value === '') return 'blank';
        const n = Number(value);
        return Number.isFinite(n) ? n.toFixed(2) : String(value);
    }

    private getRequiredCommentEntriesForPending(): IRequiredCommentEntry[] {
        const today = moment(new Date()).format('MM/DD/YYYY');
        const entries: IRequiredCommentEntry[] = [];

        this.pendingTimeCardUpdates.forEach((tc, key) => {
            const createDate = tc?.CreateDate
                ? moment(tc.CreateDate).format('MM/DD/YYYY')
                : null;
            const requiresComment = !!createDate && createDate !== today;

            if (!requiresComment) return;

            entries.push({
                key,
                task: tc.TaskDisplay || tc.TaskLongName || 'Time Entry',
                date:
                    tc.WorkDateHdr ||
                    (tc.WorkDate
                        ? moment(tc.WorkDate).format('MM/DD/YYYY')
                        : ''),
                comment: tc.ChangeComment || '',
                changeSummary: this.pendingOriginalHours.has(key)
                    ? `${this.formatHoursForChangeSummary(this.pendingOriginalHours.get(key))} -> ${this.formatHoursForChangeSummary(tc.EmployeeHours)}`
                    : `Updated to ${this.formatHoursForChangeSummary(tc.EmployeeHours)}`
            });
        });

        return entries;
    }

    /**
     * Emit all pending timecard updates and clear pending state. Table and weekly summary refresh via effects.
     */
    saveAllPending(): void {
        // Blank hours are never a valid save (clears of saved time use 0).
        const toSave = Array.from(this.pendingTimeCardUpdates.values()).filter(
            tc => tc?.EmployeeHours != null
        );
        if (toSave.length === 0) {
            this.pendingTimeCardUpdates.clear();
            this.pendingOriginalHours.clear();
            this.setHasUnsavedChanges(false);
            return;
        }

        const requiredCommentEntries = this.getRequiredCommentEntriesForPending();
        const hasMissingRequiredComment = requiredCommentEntries.some(
            entry => !entry.comment || entry.comment.trim() === ''
        );
        if (hasMissingRequiredComment) {
            this.requiredCommentEntries = requiredCommentEntries;
            this.bulkCommentMsgs = [];
            this.bulkCommentActiveTabIndex = 0;
            this.displayBulkCommentPopup = true;
            return;
        }

        toSave.forEach(tc => {
            if (tc) (tc as ITimeCard).CurrentUserListID = this.employeeListID;
        });
        this.timeCardUpdate.emit(toSave);
        this.pendingTimeCardUpdates.clear();
        this.pendingOriginalHours.clear();
        this.requiredCommentEntries = [];
        this.bulkCommentActiveTabIndex = 0;
        this.setHasUnsavedChanges(false);
    }

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent): void {
        if (this.hasUnsavedChanges) {
            event.preventDefault();
            (event as any).returnValue = 'You have unsaved timecard changes.';
        }
    }

    generateToolTips(cell, rowdata, day) {
        if (this.isSupervisor === true || this.isTaskManager === true) {
            if (rowdata[day] && rowdata[day].ReadOnlyReason) {
                return rowdata[day].ReadOnlyReason;
            } else {
                return 'Cell is read-only while performing management action.'
            }
        } else {
            if (rowdata[day] && rowdata[day].ReadOnlyReason != null) {
                return rowdata[day].ReadOnlyReason;
            }

            // if (rowdata[day] && rowdata[day].IsReadOnly === true) {
            //     return rowdata[day].ReadOnlyReason;
            // }
        }
    }

    createEmptyTabulator(tc: TimeCardPresenterComponent, container: string) {
        const maxHeightVh = tc.timecardMaxHeightVh;
        this.tabTimeCard = new Tabulator(container, {
            placeholder: 'No Data Available',
            height: '29vh', // Fixed minimum height
            maxHeight: `${maxHeightVh}vh`, // Maximum height before scrolling
            autoResize: true,
            layout: 'fitColumns',
            data: [],
            index: 'empAuthID',
            renderComplete: function () {
                if (tc.timecardData.length > 0) {
                    tc.IsLoading = false;
                } else {
                    tc.IsLoading = true;
                }
                setTimeout(() => {
                    tc.adjustTimecardHeightForWeeklySummary();
                }, 0);
            },
            columns: []
        });
    }
    createTabulatorForTimeCard(
        tc: TimeCardPresenterComponent,
        errors: Array<string>,
        tabledata: any[]
    ) {
        const headerClicked = false;
        tc.log.verbose({
            type: 'TimeCardPresenterComponent:createTabulatorForTimeCard',
            tabledata
        });

        const editCheck = function (cell) {
            const data = cell.getData();
            const column = cell.getColumn();
            const columnDef = column.getDefinition();
            const columnField = columnDef.field.split('.')[0];

            const Day = columnField;
            if (data[Day].IsReadOnly === true) {
                return false;
            } else {
                if (tc.isSupervisor === true || tc.isTaskManager === true) {
                    return false;
                } else {
                    return true;
                }
            }
        };

        const taskformatter = function (cell) {
            const data = cell.getData();
            const column = cell.getColumn();
            const columnDef = column.getDefinition();
            const columnField = columnDef.field.split('.')[0];
            const day = columnField;

            //cell.getElement().style.height = '35px';
            //cell.getElement().style.lineHeight = '23px'; // 27

            if (cell._cell.column.field === 'serviceItem') {
                cell.getElement().classList.add('default-cursor');
            }

            if (cell._cell.column.field === 'payrollItem') {
                cell.getElement().classList.add('default-cursor');
            }

            if (cell._cell.column.field === 'task') {
                cell.getElement().classList.add('default-cursor');
                // Task column should always use PrimeNG row background for theme reactivity
                cell.getElement().classList.add('timecard-cell-task-only');
                console.log('Applied task column theme-reactive class');
            }

            if (
                (data[day] && data[day].IsReadOnly) === true ||
                (data[day] && data[day].OutOfDateRange) === true
            ) {
                cell.getElement().classList.add('disabledTimeCardCell');
            } else if (cell._cell.column.field !== 'task') {
                // Only apply white background to non-task columns
                cell.getElement().style.backgroundColor = 'white';
            }
            const value = cell.getValue();
            if (value === '') {
                cell.setValue(null, true);
            }
            return value;
        };

        const statusColor = CellColorManager.createCellFormatter(tc, (cell, data, day) => {
            // Log for debugging
            tc.log.verbose({
                type: 'TimeCardPresenterComponent:createTabulatorForTimeCard:statusColor',
                data
            });

            // Return any additional context overrides if needed
            return {};
        });

        const maxHoursValidation = function (cell) {
            const row = cell.getRow();
            const data = row.getData();
            const column = cell.getColumn();
            const columnDef = column.getDefinition();
            const columnField = columnDef.field.split('.')[0];
            const day = columnField;
            tc.log.verbose({
                type: 'TimeCardPresenterComponent:maxHoursValidation',
                data
            });

            if (data[day].LeavePayout === true) {
                return 'max:1000';
            } else {
                return 'max:24';
            }
        };

        const roundValue = function (cell, places) {
            const value = +cell.getValue();
            const factor = 10 ** places;
            return Math.round(value * factor) / factor;
        };

        const maxHeightVh = tc.timecardMaxHeightVh;
        tc.tabTimeCard = new Tabulator('#tabTimeCard', {
            placeholder: 'No Data Available',
            height: tc.dynamicTableHeight,
            maxHeight: `${maxHeightVh}vh`,
            autoResize: true,
            tooltipGenerationMode: 'hover',
            layout: 'fitColumns',
            data: tabledata,
            index: 'empAuthID',
            renderComplete: function () {
                if (tc.timecardData.length > 0) {
                    tc.IsLoading = false;
                } else {
                    tc.IsLoading = true;
                }
            },
            rowFormatter: row => {
                //row.getElement().style.height = '26.6px'; // "34px";
            },
            columns: [
                {
                    field: 'empAuthID',
                    frozen: true,
                    visible: false
                },
                // 3 Page Specific Columns
                {
                    title: 'Available </br> Hours',
                    field: 'availableHours',
                    width: 90,
                    visible: tc.showAvailableHoursColumn
                },
                {
                    field: 'task',
                    minWidth: 275,
                    headerSort: true,
                    hozAlign: 'left',
                    headerFilter: true,
                    formatter: taskformatter,
                    titleFormatter: c => {
                        // Might be able to use getElement() to format the header filter to say Filter Tasks...
                        return document.getElementById('taskColumnHeader');
                    },
                    cellDblClick: (e, c) => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        this.log.verbose({
                            type: 'TimeCardPresenterComponent:taskcolumn:dblclick',
                            url: rowdata.empAuthURL
                        });
                        if (rowdata.empAuthURL != null) {
                            window.open(rowdata.empAuthURL, '_blank');
                        }
                    }
                },
                {
                    title: 'Payroll </br> Item',
                    field: 'payrollItem',
                    visible: false,
                    width: 300,
                    headerSort: false,
                    formatter: taskformatter
                },
                {
                    title: 'Day0 Hours',
                    field: 'Day0.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tabledata[0].Day0 ? true : false,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day0');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day0) {
                            if (tabledata[0].Day0.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day0.DateColor;
                            }
                            if (tabledata[0].Day0.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day0.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day0') &&
                                this.hasProp(tabledata[0].Day0, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day0.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Day1 Hours',
                    field: 'Day1.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tabledata[0].Day1 ? true : false,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day1');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day1) {
                            if (tabledata[0].Day1.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day1.DateColor;
                            }
                            if (tabledata[0].Day1.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day1.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day1') &&
                                this.hasProp(tabledata[0].Day1, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day1.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Day2 Hours',
                    field: 'Day2.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tabledata[0].Day2 ? true : false,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day2');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day2) {
                            if (tabledata[0].Day2.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day2.DateColor;
                            }
                            if (tabledata[0].Day2.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day2.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day2') &&
                                this.hasProp(tabledata[0].Day2, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day2.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Day3 Hours',
                    field: 'Day3.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tabledata[0].Day3 ? true : false,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day3');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day3) {
                            if (tabledata[0].Day3.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day3.DateColor;
                            }
                            if (tabledata[0].Day3.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day3.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day3') &&
                                this.hasProp(tabledata[0].Day3, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day3.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Day4 Hours',
                    field: 'Day4.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tabledata[0].Day4 ? true : false,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day4');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day4) {
                            if (tabledata[0].Day4.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day4.DateColor;
                            }
                            if (tabledata[0].Day4.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day4.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day4') &&
                                this.hasProp(tabledata[0].Day4, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day4.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Day5 Hours',
                    field: 'Day5.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();

                        // return cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tabledata[0].Day5 ? true : false,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day5');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day5) {
                            if (tabledata[0].Day5.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day5.DateColor;
                            }
                            if (tabledata[0].Day5.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day5.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day5') &&
                                this.hasProp(tabledata[0].Day5, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day5.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Day6 Hours',
                    field: 'Day6.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tabledata[0].Day6 ? true : false,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day6');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day6) {
                            if (tabledata[0].Day6.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day6.DateColor;
                            }
                            if (tabledata[0].Day6.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day6.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day6') &&
                                this.hasProp(tabledata[0].Day6, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day6.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Day7 Hours',
                    field: 'Day7.EmployeeHours',
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    width: 58,
                    headerSort: false,
                    editor: 'number',
                    validator: [maxHoursValidation],
                    editable: editCheck,
                    visible: tc.PeriodHasSplitDay,
                    formatter: statusColor,
                    tooltip: c => {
                        const row = c.getRow();
                        const rowdata = row.getData();
                        return tc.generateToolTips(c, rowdata, 'Day7');
                    },
                    titleFormatter: c => {
                        if (tabledata[0].Day7) {
                            if (tabledata[0].Day7.DateColor != null) {
                                c.getElement().style.fontWeight = 'bold';
                                c.getElement().style.color =
                                    tabledata[0].Day7.DateColor;
                            }
                            if (tabledata[0].Day7.DatePurpose != null) {
                                c.getElement().title =
                                    tabledata[0].Day7.DatePurpose;
                            }
                            if (
                                this.hasProp(tabledata[0], 'Day7') &&
                                this.hasProp(tabledata[0].Day7, 'WorkDateHdr')
                            ) {
                                const splithdr =
                                    tabledata[0].Day7.WorkDateHdr.split(' ');
                                return `${splithdr[0]} </br> ${splithdr[1]}`;
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    title: 'Weekly <br/> Total',
                    field: 'weeklyTotal',
                    hozAlign: 'center',
                    width: 65,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    headerSort: false,
                    formatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        const row = cell.getRow();
                        const rowdata = row.getData();
                        const updatedData = tc.sortedByTask.find(
                            x => x.empAuthID === rowdata.empAuthID
                        );
                        cell.getElement().style.fontWeight = 'bold';
                        cell.getElement().classList.add('disabledTimeCardCell');
                        const value = cell.getValue();
                        return value != null && value !== ''
                            ? value
                            : updatedData?.weeklyTotal;
                    }
                },
                {
                    title: 'Documented <br/> Total',
                    field: 'TotalDocumentedHours',
                    hozAlign: 'center',
                    width: 95,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    headerSort: false,
                    formatter: cell => {
                        cell.getElement().style.height = '35px';
                        cell.getElement().style.lineHeight = '27px';
                        const row = cell.getRow();
                        const rowdata = row.getData();
                        const updatedData = tc.sortedByTask.find(
                            x => x.empAuthID === rowdata.empAuthID
                        );
                        cell.getElement().style.fontWeight = 'bold';
                        cell.getElement().classList.add('disabledTimeCardCell');
                        return cell.getValue()
                            ? cell.getValue()
                            : updatedData.TotalDocumentedHours;
                    }
                },
                { title: '', field: 'Row_Version', width: 55, visible: false }
            ],
            cellEdited: cell => {
                const row = cell.getRow();
                const rowdata = row.getData();
                const column = cell.getColumn();
                const columnDef = column.getDefinition();
                const columnField = columnDef.field.split('.')[0];
                const day = columnField;

                if (cell.getValue() != null) {
                    if (rowdata[day].InterfaceType == "Timer") {
                        this.confirmservice
                            .confirmPromise({
                                headerText: "Are you sure?",
                                dialogText:
                                    `Updating this time entry will override timer activity.`,
                                okText: 'Yes',
                                cancelText: 'No'
                            })
                            .then(() => {
                                // Apply colors using centralized manager
                                this.applyCellEditColors(cell);

                                const numberOfDecimals = tc.countDecimals(+cell.getValue());
                                if (numberOfDecimals <= +tc.companySettings[0].SettingValue) {
                                    tc.updateTime(cell);
                                } else {
                                    tc.revertRowToPreviousValue(cell);
                                    alert(
                                        `Hours are entered with up to ${tc.companySettings[0].SettingValue} decimals places.`
                                    );
                                }
                                return;
                            })
                            .catch(() => {
                                this.revertRowToPreviousValue(cell);
                                return;
                            });
                    } else {
                        // Apply colors using centralized manager
                        this.applyCellEditColors(cell);

                        const numberOfDecimals = tc.countDecimals(+cell.getValue());
                        if (numberOfDecimals <= +tc.companySettings[0].SettingValue) {
                            tc.updateTime(cell);
                        } else {
                            tc.revertRowToPreviousValue(cell);
                            alert(
                                `Hours are entered with up to ${tc.companySettings[0].SettingValue} decimals places.`
                            );
                        }
                    }
                } else {
                    // Cell has no value - this will be handled by updateTime method
                    tc.updateTime(cell);
                }

                this.disableRefreshButton = false;
            },
            cellEditing: cell => {
                tc.log.verbose({
                    type: 'TimeCardPresenterComponent:tabTimeCard:cellEditing',
                    cell: cell.getValue()
                });
            },
            cellClick: (e, cell) => {
                tc.log.verbose({
                    type: 'TimeCardPresenterComponent:tabTimeCard:cellClick',
                    cell: cell.getValue()
                });
                const value = cell.getRow().getData();
                tc.log.verbose({
                    type: 'TimeCardPresenterComponent:tabTimeCard:cellClick',
                    value
                });
                if (tc.isSupervisor == false && tc.isTaskManager == false) {
                    if (cell.getValue() || cell.getValue() === 0) {
                        e.currentTarget.children[0].select();
                    }
                }
            },
            cellTap: (e, cell) => {
                if (tc.isSupervisor == false && tc.isTaskManager == false) {
                    if (cell.getValue() || cell.getValue() === 0) {
                        e.currentTarget.children[0].select();
                    }
                }
            },
            rowClick: this.tabService.rowMouseHandler,
            rowTap: this.tabService.rowMouseHandler,
            cellDblClick: (e, c) => {
                if (c.getValue() || c.getValue() == 0) {
                    const row = c.getRow();
                    tc.currentRow = row;
                    const rowdata = row.getData();
                    const column = c.getColumn();
                    const columnDef = column.getDefinition();
                    const columnField = columnDef.field.split('.')[0];
                    const day = columnField;
                    tc.currentDay = day;
                    tc.selectedCellValue = c.getValue();
                    tc.selectedCellDate = moment(rowdata[day].WorkDate).format(
                        'MM/DD/YYYY'
                    );
                    tc.selectedCellTask = rowdata.task;
                    if (tc.isSupervisor == true || tc.isTaskManager == true) {
                        switch (rowdata[day].TimeStatus) {
                            case 0.0:
                                tc.selectedCellStatus = 'Saved';
                                tc.displayManagementActionErrorDialog();
                                break;
                            case 1.0:
                                tc.selectedCellStatus = 'Signed';
                                tc.displayManagementActionDialog();
                                break;
                            case 1.5:
                                tc.selectedCellStatus = 'Validated';
                                tc.displayManagementActionDialog();
                                break;
                            case 2.0:
                                tc.selectedCellStatus = 'Approved';
                                tc.displayManagementActionDialog();
                                break;
                            case 3.0:
                                tc.selectedCellStatus = 'Disapproved';
                                tc.displayManagementActionDialog();
                                break;
                            default:
                                tc.selectedCellStatus = '';
                                break;
                        }

                    } else {
                        if (rowdata[day].EmpTimeID == null) {
                            this.confirmservice
                                .confirmPromise({
                                    dialogText:
                                        'Time entries must be saved before they are available for documentation.',
                                    okText: 'OK',
                                    showCancel: false,
                                })
                                .then(() => {   
                                    return;                                 
                                })                               
                        }
                        if (rowdata[day].EmpTimeID != null) {
                            if (tc.hasStagedTimecardEdits()) {
                                void tc.confirmservice
                                    .confirmPromise({
                                        dialogText:
                                            'Timecard Documentation cannot be opened with unsaved changes in the timecard.',
                                        okText: 'OK',
                                        showCancel: false,
                                    })
                                    .then(() => undefined)
                                    .catch(() => undefined);
                            } else {
                                tc.AddDocumentation.next(tc.getTimecardDay(c));
                            }
                        }
                    }
                }
            },
            cellDblTap: (e, c) => {
                if (c.getValue() || c.getValue() == 0) {
                    const row = c.getRow();
                    tc.currentRow = row;
                    const rowdata = row.getData();
                    const column = c.getColumn();
                    const columnDef = column.getDefinition();
                    const columnField = columnDef.field.split('.')[0];
                    const day = columnField;
                    tc.currentDay = day;
                    tc.selectedCellValue = c.getValue();
                    tc.selectedCellDate = moment(rowdata[day].WorkDate).format(
                        'MM/DD/YYYY'
                    );
                    tc.selectedCellTask = rowdata.task;
                    if (tc.isSupervisor == true || tc.isTaskManager == true) {
                        switch (rowdata[day].TimeStatus) {
                            case 0.0:
                                tc.selectedCellStatus = 'Saved';
                                break;
                            case 1.0:
                                tc.selectedCellStatus = 'Signed';
                                break;
                            case 1.5:
                                tc.selectedCellStatus = 'Validated';
                                break;
                            case 2.0:
                                tc.selectedCellStatus = 'Approved';
                                break;
                            case 3.0:
                                tc.selectedCellStatus = 'Disapproved';
                                break;
                            default:
                                tc.selectedCellStatus = '';
                                break;
                        }
                        tc.displayManagementActionDialog();
                    } else {
                        if (rowdata[day].EmpTimeID == null) {
                            this.confirmservice
                                .confirmPromise({
                                    dialogText:
                                        'Time entries must be saved before they are available for documentation.',
                                    okText: 'OK',
                                    showCancel: false,
                                })
                                .then(() => {   
                                    return;                                 
                                })                               
                        }
                        if (rowdata[day].EmpTimeID != null) {
                            if (tc.hasStagedTimecardEdits()) {
                                void tc.confirmservice
                                    .confirmPromise({
                                        dialogText:
                                            'Timecard Documentation cannot be opened with unsaved changes in the timecard.',
                                        okText: 'OK',
                                        showCancel: false,
                                    })
                                    .then(() => undefined)
                                    .catch(() => undefined);
                            } else {
                                tc.AddDocumentation.next(tc.getTimecardDay(c));
                            }
                        }
                    }
                }
                if (!this.isApprovalOrValidationView) {
                    setTimeout(() => {
                        this.adjustTimecardHeightForWeeklySummary();
                    }, 0);
                }
            }
        });
        // }
    }

    displayManagementActionDialog() {
        this.showManagementActionDialog = true;
    }

    displayManagementActionErrorDialog() {
        this.showManagementActionErrorDialog = true;
    }

    refreshStatus() {
        this.pivot = true;
        this.isRefreshing = true;
        const date = this.sortedByTask[0].Day0.WorkDate.toString();
        if (this.isDRSelected) {
            this.refreshStatusEE.emit({
                empListID: this.directReportListID,
                date: date,
                direction: ''
            });
        } else {
            this.refreshStatusEE.emit({
                empListID: this.sortedByTask[0].Day0.EmployeeListID,
                date: date,
                direction: ''
            });
        }
        this.disableRefreshButton = true;
    }



    getCurrentActiveTab(): string {
        return null;
    }

    isApproveTabActive(): boolean {
        return this.isSupervisor;
    }

    isUnapproveTabActive(): boolean {
        return this.isSupervisor;
    }

    isDisapproveTabActive(): boolean {
        return this.isSupervisor;
    }

    isValidateTabActive(): boolean {
        return this.isTaskManager;
    }

    isDisapproveValidateTabActive(): boolean {
        return this.isTaskManager;
    }

    isUnvalidateTabActive(): boolean {
        return this.isTaskManager;
    }

    onDateForRangeSelected(value) {
        this.log.verbose({
            type: 'TimeCardPresenterComponent:onDateForRangeSelected',
            value
        });

        if (this.firstDate != null) {
            this.secondDate = value;
        } else {
            this.firstDate = value;
        }
        if (this.firstDate != null && this.secondDate != null) {
            if (this.firstDate > this.secondDate) {
                this.firstDate = value;
                this.secondDate = null;
                this.fullDateRangeSelected = false;
            } else {
                this.fullDateRangeSelected = true;
                this.firstDate = null;
                this.secondDate = null;
            }
        } else {
            this.fullDateRangeSelected = false;
        }
    }

    createTabulatorForManagementUsers(
        tc: TimeCardPresenterComponent,
        tableData: any,
        errors: Array<string>
    ) {
        let headerClicked;
        function columnVisibility() {
            if (tc.userWebColors) {
                const validateColor = tc.userWebColors.find(
                    x => x.Status === 'Validated'
                );
                if (validateColor == null) {
                    return false;
                } else {
                    return true;
                }
            }
        }
        if (this.isSupervisor || this.isTaskManager) {
            this.tabManagement = new Tabulator('#tabManagement', {
                placeholder: 'No Data Available',
                height: '21vh',//'50.15vh',
                autoResize: true,
                layout: 'fitColumns',
                data: tableData,
                tooltipGenerationMode: 'hover',
                index: 'EmployeeListID',
                rowSelectionChanged: function (data, rows) {
                    // rows - array of row components for the selected rows in order of selection
                    // data - array of data objects for the selected rows in order of selection
                    if (rows.length > 0) {
                        for (let i = 0; i < rows.length; i++) {
                            const rowdata = rows[i].getData();
                            tc.dRtoAdd.push({
                                EmployeeListID: rowdata.EmployeeListID,
                                EmployeeName: 'na',
                                IsActive: 1
                            });
                        }
                        if (
                            tc.fullDateRangeSelected === true &&
                            tc.dRtoAdd.length > 0
                        ) {
                            tc.IsDisabled = false;
                        }
                        if (tc.dRtoAdd.length === 0) {
                            tc.IsDisabled = true;
                        }
                        tc.selectedDirectReports = tc.dRtoAdd;
                        tc.dRtoAdd = [];
                    }
                    if (rows.length == 0) {
                        tc.IsDisabled = true;
                    }
                },
                columns: [
                    {
                        title: 'Id',
                        field: 'ListID',
                        visible: false,
                        formatter: cell => {
                            tc.mgmtCell = cell;
                        },
                        frozen: true
                    },
                    // Selected
                    {
                        formatter: 'rowSelection',
                        titleFormatter: 'rowSelection',
                        hozAlign: 'center',
                        headerSort: false,
                        width: 50,
                        frozen: true
                    },
                    // Page Specific Columns
                    {
                        title: 'Name',
                        field: 'UserName',
                        headerTooltip: true,
                        minWidth: 250,
                        frozen: true
                    },
                    {
                        title: 'Saved',
                        field: 'Saved',
                        headerTooltip: true,
                        titleFormatter: c => {
                            return `Saved`;
                        },
                        tooltip: c => {
                            return 'Saved';
                        },
                        visible: this.requireTimeSubmit,
                        width: 120,
                        hozAlign: 'center',
                        formatter: c => {
                            const value = c.getValue();
                            const data = c.getData();
                            if (value === '') {
                                c.setValue(null, true);
                                c.getElement().style.backgroundColor = 'white';
                                c.getElement().style.color = 'black';
                            }
                            if (value) {
                                const color = tc.userWebColors.find(
                                    x => x.Status === 'Saved'
                                );
                                if (color != null) {
                                    c.getElement().style.backgroundColor =
                                        color.Backcolor_hex;
                                    c.getElement().style.color =
                                        color.Forecolor_Hex;
                                }
                                return value;
                            }
                        }
                    },
                    {
                        title: 'Signed',
                        field: 'Signed',
                        headerTooltip: true,
                        titleFormatter: c => {
                            return `Signed`;
                        },
                        tooltip: c => {
                            return 'Signed';
                        },
                        width: 100,
                        hozAlign: 'center',
                        formatter: c => {
                            const value = c.getValue();
                            const data = c.getData();
                            if (value === '') {
                                c.getElement().style.backgroundColor = 'white';
                                c.getElement().style.color = 'black';
                                c.setValue(null, true);
                            }

                            if (value) {
                                const color = tc.userWebColors.find(
                                    x => x.Status === 'Signed'
                                );
                                if (color != null) {
                                    c.getElement().style.backgroundColor =
                                        color.Backcolor_hex;
                                    c.getElement().style.color =
                                        color.Forecolor_Hex;
                                }
                                return value;
                            }
                        }
                    },
                    {
                        title: 'Validated',
                        field: 'Validated',
                        headerTooltip: true,
                        titleFormatter: c => {
                            return `Validated`;
                        },
                        tooltip: c => {
                            return 'Validated';
                        },
                        visible: columnVisibility(),
                        width: 100,
                        hozAlign: 'center',
                        formatter: c => {
                            const value = c.getValue();
                            if (value === '') {
                                c.setValue(null, true);
                                c.getElement().style.backgroundColor = 'white';
                                c.getElement().style.color = 'black';
                                return value;
                            }
                            if (value) {
                                const color = tc.userWebColors.find(
                                    x => x.Status === 'Validated'
                                );
                                if (color != null) {
                                    c.getElement().style.backgroundColor =
                                        color.Backcolor_hex;
                                    c.getElement().style.color =
                                        color.Forecolor_Hex;
                                }
                                return value;
                            }
                        }
                    },
                    {
                        title: 'Approved',
                        field: 'Approved',
                        headerTooltip: true,
                        titleFormatter: c => {
                            return `Approved`;
                        },
                        tooltip: c => {
                            return 'Approved';
                        },
                        width: 100,
                        hozAlign: 'center',
                        formatter: c => {
                            const value = c.getValue();
                            if (value === '') {
                                c.setValue(null, true);
                                c.getElement().style.backgroundColor = 'white';
                                c.getElement().style.color = 'black';
                                return value;
                            }
                            if (value) {
                                const color = tc.userWebColors.find(
                                    x => x.Status === 'Approved'
                                );
                                if (color != null) {
                                    c.getElement().style.backgroundColor =
                                        color.Backcolor_hex;
                                    c.getElement().style.color =
                                        color.Forecolor_Hex;
                                }
                                return value;
                            }
                        }
                    },
                    {
                        title: 'Disapproved',
                        field: 'Disapproved',
                        headerTooltip: true,
                        titleFormatter: c => {
                            return `Disapproved`;
                        },
                        tooltip: c => {
                            return 'Disapproved';
                        },
                        width: 105,
                        hozAlign: 'center',
                        formatter: c => {
                            const value = c.getValue();
                            if (value === '') {
                                c.setValue(null, true);
                                c.getElement().style.backgroundColor = 'white';
                                c.getElement().style.color = 'black';
                                return value;
                            }
                            if (value) {
                                const color = tc.userWebColors.find(
                                    x => x.Status === 'Disapproved'
                                );
                                if (color != null) {
                                    c.getElement().style.backgroundColor =
                                        color.Backcolor_hex;
                                    c.getElement().style.color =
                                        color.Forecolor_Hex;
                                }
                                return value;
                            }
                        }
                    },
                    {
                        title: 'Leave',
                        field: 'LeaveAccrualInfo',
                        headerTooltip: true,
                        width: 175
                    },
                    {
                        title: 'Manually Locked',
                        field: 'LockedDate',
                        headerTooltip: true,
                        width: 150,
                        formatter: cell => {
                            if (cell.getValue()) {
                                return moment(cell.getValue()).format(
                                    'MM/DD/YYYY'
                                );
                            } else {
                                return cell.getValue();
                            }
                        }
                    },
                    { title: '', field: 'Row_Version', visible: false }
                ],
                cellEdited: this.tabService.cellEdited,
                cellEditing: this.tabService.cellEditing,
                cellClick: this.tabService.cellMouseHandler,
                cellTap: this.tabService.cellMouseHandler,
                rowClick: (e, row) => {
                    const data = row.getData();
                    tc.isDRSelected = true;
                    this.pivot = true;
                    const rows = tc.tabManagement.getRows();
                    rows.forEach(row => {
                        row.getElement().classList.remove('highlight');
                    });
                    this.prevButtonHidden = false;
                    this.nextButtonHidden = false;
                    this.displayDocWarning = false;
                    this.displayOver24HoursWarning = false;
                    this.dRSelectedSubject.next(data);
                    tc.DRName = data.UserName;
                    tc.directReportListID = data.EmployeeListID;
                    tc.selectedDRRow = row;
                    row.getElement().classList.add('highlight');
                    tc.tabTimeCard.clearData();
                    this.detailsLabel = `HR Details for ${data.UserName}`;
                    if (tc.managementActionEndDate == null) {
                        tc.managementActionEndDate = moment(new Date()).format(
                            'MM/DD/YYYY'
                        );
                    }
                    const dataToEmit = {
                        EmployeeListID: data.EmployeeListID,
                        TimeCardDate: tc.mgmtDateRangeStart,
                        Direction: null
                    };
                    if (this.isSupervisor) {
                        this.weeklySummaryHeader =
                            'Weekly Summary for Approval Period';
                    } else if (this.isTaskManager) {
                        this.weeklySummaryHeader =
                        'Weekly Summary for Validate Period';
                    } else {
                        if (data.AccountNumber != null) {
                            this.weeklySummaryHeader =
                                'Weekly View' +
                                '\xa0\xa0' +
                                data.UserName +
                                '\xa0\xa0' +
                                data.WebEntryPeriod;
                        } else {
                            this.weeklySummaryHeader =
                                'Weekly View' +
                                '\xa0\xa0' +
                                data.UserName +
                                '\xa0\xa0' +
                                data.WebEntryPeriod;
                        }
                    }
                },
                rowTap: this.tabService.rowMouseHandler
            });
        }
    }

    createEmptyWeeklyTabulator(
        tc: TimeCardPresenterComponent,
        container: string
    ) {
        this.tabWeeklySummary = new Tabulator(container, {
            placeholder: this.emptyWeeklyTabPlaceholder,
            height: tc.dynamicSummaryTableHeight,
            width: '100%',
            autoResize: false,
            layout: 'fitDataStretch',
            data: [],
            index: 'empAuthID',
            renderComplete: function () {
                if (tc.timecardData.length > 0) {
                    tc.IsLoading = false;
                } else {
                    tc.IsLoading = true;
                }
            },
            columns: []
        });
    }
    createTabulatorForWeeklySummary(
        tc: TimeCardPresenterComponent,
        errors: Array<string>,
        tableData: any
    ) {
        const headerClicked = false;

        // Function to create week header button
        const createWeekHeaderButton = (weekIndex: number, tableData: any, tc: TimeCardPresenterComponent) => {
            return () => {
                if (tableData[0][`Week${weekIndex}`]) {
                    const timeWeek = tableData[0][`Week${weekIndex}`].TimeWeek;
                    tc[`timeweek${weekIndex}`] = timeWeek;

                    const b = document.createElement('button');
                    const node = document.createTextNode(timeWeek);
                    b.appendChild(node);
                    b.classList.add('pButton', 'p-button-link', 'weekHeader');
                    b.style.color = 'white';
                    b.style.fontSize = '11px';
                    b.style.padding = '0';
                    b.style.textDecoration = 'underline';
                    b.setAttribute('link', '');
                    return b != null ? b : timeWeek;
                } else {
                    return '';
                }
            };
        };

        const roundValue = function (cell, places) {
            const value = +cell.getValue();
            const factor = 10 ** places;
            return Math.round(value * factor) / factor;
        };

        this.tabWeeklySummary = new Tabulator('#tabWeeklySummary', {
            placeholder: 'No Data Available',
            height: 'auto',
            maxHeight: '17vh',
            width: '100%',
            autoResize: false,
            layout: 'fitColumns',
            data: tableData,
            columns: [
                { title: 'Id', field: 'ListID', visible: false },
                // Selected
                // 3 Page Specific Columns
                {
                    title: 'Task',
                    field: 'task',
                    minWidth: 275
                },
                {
                    title: 'Payroll Item',
                    field: 'payrollItem',
                    width: 300,
                    visible: false
                },
                {
                    title: 'Authorization Period',
                    field: 'empAuthPeriod',
                    width: 165,
                    visible: true
                },
                {
                    title: 'Available Hours',
                    field: 'availableHours',
                    width: 150,
                    editable: false,
                    visible: tableData[0].showAvailHours
                },
                {
                    title: 'Week0 Hours',
                    field: 'Week0.EmployeeHours',
                    width: 125,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,
                    editable: false,
                    visible: tableData[0].Week0 ? true : false,
                    headerClick: () => {
                        tc.weeklyHeaderClicked(0);
                    },
                    formatter: c => {
                        const value = c.getValue();
                        if (value) {
                            return value;
                        } else {
                            if (value === '') {
                                return null;
                            } else {
                                return value;
                            }
                        }
                    },
                    titleFormatter: createWeekHeaderButton(0, tableData, tc)
                },
                {
                    title: 'Week1 Hours',
                    field: 'Week1.EmployeeHours',
                    width: 145,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,
                    editable: false,
                    visible: tableData[0].Week1 ? true : false,
                    headerClick: () => {
                        tc.weeklyHeaderClicked(1);
                    },
                    formatter: c => {
                        const value = c.getValue();
                        if (value === '') {
                            c.setValue(null, true);
                            return value;
                        } else {
                            return value;
                        }
                    },
                    titleFormatter: createWeekHeaderButton(1, tableData, tc)
                },
                {
                    title: 'Week2 Hours',
                    field: 'Week2.EmployeeHours',
                    width: 145,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,
                    editable: false,
                    visible: tableData[0].Week2 ? true : false,
                    headerClick: () => {
                        tc.weeklyHeaderClicked(2);
                    },
                    formatter: c => {
                        const value = c.getValue();
                        if (value === '') {
                            c.setValue(null, true);
                            return value;
                        } else {
                            return value;
                        }
                    },
                    titleFormatter: createWeekHeaderButton(2, tableData, tc)
                },
                {
                    title: 'Week3 Hours',
                    field: 'Week3.EmployeeHours',
                    width: 145,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,
                    editable: false,
                    visible: tableData[0].Week3 ? true : false,
                    headerClick: () => {
                        tc.weeklyHeaderClicked(3);
                    },
                    formatter: c => {
                        const value = c.getValue();
                        if (value === '') {
                            c.setValue(null, true);
                            return value;
                        } else {
                            return value;
                        }
                    },
                    titleFormatter: createWeekHeaderButton(3, tableData, tc)
                },
                {
                    title: 'Week4 Hours',
                    field: 'Week4.EmployeeHours',
                    width: 145,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,
                    editable: false,
                    visible: tableData[0].Week4 ? true : false,
                    headerClick: () => {
                        tc.weeklyHeaderClicked(4);
                    },
                    formatter: c => {
                        const value = c.getValue();
                        if (value === '') {
                            c.setValue(null, true);
                            return value;
                        } else {
                            return value;
                        }
                    },
                    titleFormatter: createWeekHeaderButton(4, tableData, tc)
                },
                {
                    title: 'Week5 Hours',
                    field: 'Week5.EmployeeHours',
                    width: 145,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,
                    editable: false,
                    visible: tableData[0].Week5 ? true : false,
                    headerClick: () => {
                        tc.weeklyHeaderClicked(5);
                    },
                    formatter: c => {
                        const value = c.getValue();
                        if (value === '') {
                            c.setValue(null, true);
                            return value;
                        } else {
                            return value;
                        }
                    },
                    titleFormatter: createWeekHeaderButton(5, tableData, tc)
                },
                {
                    title: 'Week6 Hours',
                    field: 'Week6.EmployeeHours',
                    width: 145,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,
                    editable: false,
                    visible: tableData[0].Week6 ? true : false,
                    headerClick: () => {
                        tc.weeklyHeaderClicked(6);
                    },
                    formatter: c => {
                        const value = c.getValue();
                        if (value === '') {
                            c.setValue(null, true);
                            return value;
                        } else {
                            return value;
                        }
                    },
                    titleFormatter: createWeekHeaderButton(6, tableData, tc)
                },
                {
                    title: 'Period Total',
                    field: 'periodTotal',
                    width: 100,
                    bottomCalc: 'sum',
                    bottomCalcFormatter: cell => {
                        return tc.companySettings && tc.companySettings[0]
                            ? roundValue(
                                  cell,
                                  +tc.companySettings[0].SettingValue
                              )
                            : cell.getValue();
                    },
                    hozAlign: 'center',
                    headerSort: false,

                    formatter: c => {
                        c.getElement().style.fontWeight = 'bold';
                        c.getElement().classList.add('disabledTimeCardCell');
                        return c.getValue() ? c.getValue() : '';
                    }
                },

                { title: '', field: 'Row_Version', visible: false }
            ],
            cellEdited: this.tabService.cellEdited,
            cellEditing: this.tabService.cellEditing,
            cellClick: this.tabService.cellMouseHandler,
            cellTap: this.tabService.cellMouseHandler,
            rowClick: this.tabService.rowMouseHandler,
            rowTap: this.tabService.rowMouseHandler
        });
    }

    onTabClose(e) {
        this.tc_panelExpanded = false;
    }

    weeklyHeaderClicked(week, bypassUnsavedPrompt = false) {
        if (!bypassUnsavedPrompt && this.hasStagedTimecardEdits()) {
            this.confirmLeaveUnsavedTimeEntries(() =>
                this.weeklyHeaderClicked(week, true)
            );
            return;
        }

        this.currentCell = null;
        this.pivot = true;
        this.tc_panelExpanded = true;
        this.weeklyHeaderSelected = true;
        let dateArr;
        let date;
        if (week === 0) {
            dateArr = this.timeweek0.split(' - ');
            date = `${dateArr[0]}`;
        } else if (week === 1) {
            dateArr = this.timeweek1.split(' - ');
            date = `${dateArr[0]}`;
        } else if (week === 2) {
            dateArr = this.timeweek2.split(' - ');
            date = `${dateArr[0]}`;
        } else if (week === 3) {
            dateArr = this.timeweek3.split(' - ');
            date = `${dateArr[0]}`;
        } else if (week === 4) {
            dateArr = this.timeweek4.split(' - ');
            date = `${dateArr[0]}`;
        } else if (week === 5) {
            dateArr = this.timeweek5.split(' - ');
            date = `${dateArr[0]}`;
        } else if (week === 6) {
            dateArr = this.timeweek6.split(' - ');
            date = `${dateArr[0]}`;
        } else {
            date = '';
        }

        if (this.isSupervisor || this.isTaskManager) {
            this.nextOrPrevious.emit({
                empListID: this.directReportListID,
                date: date,
                direction: null,
                processid: this.process.ProcessID,
                endDate: this.mgmtDateRangeEnd
            });
        }
        if (this.isSuperUser) {
            if (this.isDRSelected === true) {
                this.nextOrPrevious.emit({
                    empListID: this.directReportListID,
                    date: date,
                    direction: null
                });
            }
        }
        if (this.isUser) {
            this.nextOrPrevious.emit({
                empListID: this.sortedByTask[0].Day0.EmployeeListID,
                date: date,
                direction: null
            });
        }
    }

    resetTaskSortOrder() {
        const tasksWithSortOrderReset = this.timecardSequence;

        tasksWithSortOrderReset[0] = {
            ...tasksWithSortOrderReset[0],
            Tasksortorder: null
        };
        this.SaveTimecardSequence.next(tasksWithSortOrderReset[0]);
        this.LoadTimecardSequence.next();
    }
}

export interface INextOrPrevious {
    empListID: string;
    date: string;
    direction: string;
    processid?: number;
    endDate?: Date;
}

export interface IFlippedData {
    payrollItem: string;
    periodTotal: number;
    serviceItem: string;
    task: string;
    weeklyTotal: number;
    empAuthID: number;
    Day0: ITimeCard;
    Day1: ITimeCard;
    Day2: ITimeCard;
    Day3: ITimeCard;
    Day4: ITimeCard;
    Day5: ITimeCard;
    Day6: ITimeCard;
    Day7: ITimeCard;
}
export interface IFlippedWSData {
    availableHours: number;
    empAuthPeriod: string;
    payrollItem: string;
    periodTotal: number;
    serviceItem: string;
    showAvailHours: boolean;
    empAuthID: number;
    task: string;
    Week0: IWeeklySummary;
    Week1: IWeeklySummary;
    Week2: IWeeklySummary;
    Week3: IWeeklySummary;
    Week4: IWeeklySummary;
    Week5: IWeeklySummary;
    Week6: IWeeklySummary;
}
